// ** Redux Imports
import { createSlice, createAsyncThunk, isPending, isRejected, isFulfilled } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import axios from "axios"
import { isUserLoggedIn } from '@utils'
import { ApiUrls } from '../../utility/ApiUrls'
import GlobalVariable from '../../settings/global'
import themeConfig from '../../configs/themeConfig'
import { clarity } from 'react-microsoft-clarity'
import Cookies from 'universal-cookie'
const baseApiUrl = GlobalVariable.BASE_API_URL
const chunkSize = 1048576 * 7
let getUserCall = false
const myEncodeURIComponent = DefaultConfig().myEncodeURIComponent
// const getUserRole = DefaultConfig().getUserRole

// const IGNORED_ACTIONS = [
//     'appCommonReducers/GetSearchAgent'
//     // 'appCommonReducers/GetRefreshData',
//     // 'analytics/LogAnalyticsEvent'
// ]
// const shouldTrack = (actionType) => !IGNORED_ACTIONS.some((prefix) => actionType.startsWith(prefix))

const getToken = () => {
    const expiryTimestamp = localStorage.getItem('tokenExpiry')
    if (!expiryTimestamp) {
        return false
    }
    const now = new Date().getTime()
    if (now > parseInt(expiryTimestamp, 10)) {
        return false
    }

    return true
}

// Treat any datetime WITHOUT timezone as EST, convert to UTC only if time != 00:00:00
const convertESTDateTimeToUTC = (json) => {

    const isDateTime = (value) => {
        // Check 2025-12-09T12:21:58 or 2025-12-09T00:00:00
        return typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value)
    }

    const convert = (value) => {
        if (!isDateTime(value)) return value

        const timePart = value.split("T")[1]

        // Skip if time=00:00:00
        if (timePart === "00:00:00") return value

        // Convert EST → UTC by adding timezone offset
        const estString = `${value}-05:00` // mark input as EST

        return new Date(estString).toISOString()
    }

    // deep recursive function to scan all nested fields
    const traverse = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(item => traverse(item))
        } else if (obj && typeof obj === "object") {
            const newObj = {}
            for (const key in obj) {
                newObj[key] = traverse(obj[key])
            }
            return newObj
        } else {
            return convert(obj)
        }
    }

    return traverse(json)
}

const getData = (Obj) => {
    const data = convertESTDateTimeToUTC(Obj)
    return data
}

let callUiConfiguration = false

let count = 0

const getUserApiCall = () => {
    axios.get(`${GlobalVariable.hostpath}api/Common/GetUIConfiguration`)
        .then((res) => {
            const result = res.data
            callUiConfiguration = false
            if (result) {
                const data = result.data
                if (data) {
                    const azureAdB2C = data.azureAdB2C
                    const merchantOne = data.merchantOne
                    const JsScriptData = data.jsScriptData
                    azureAdB2C['apiUrl'] = GlobalVariable.hostpath
                    azureAdB2C['hostname'] = window.location.origin
                    localStorage.setItem('azureAdB2C', JSON.stringify(azureAdB2C))
                    localStorage.setItem('merchantOne', JSON.stringify(merchantOne))
                    localStorage.setItem('JsScriptData', JSON.stringify(JsScriptData))
                    const expiryTimestamp = new Date().getTime() + (data.expiryTime * 60 * 1000)
                    localStorage.setItem('expiryTime', expiryTimestamp)
                    const localStorageToken = localStorage.getItem('token')
                    axios.get(`${GlobalVariable.hostpath}api/User/GetUser`, {
                        headers: { Authorization: `Bearer ${localStorageToken}` }
                    }).then((res) => {
                        const userData = res.data
                        if (userData.success) {
                            if (userData.data) {
                                if (userData.data.isResetPassword === true) {
                                    toast(t => (<ToastMessage t={t} message={"Your password has been changed successfully. Please Login..."} status={"success"} />))
                                    setTimeout(() => {
                                        localStorage.clear()
                                        window.location.reload()
                                    }, 3000)
                                } else {
                                    const cookies = new Cookies()
                                    cookies.set('CustomClaims', res.headers["x-set-cookie"], { path: '/' })
                                    localStorage.setItem('userData', JSON.stringify(userData.data))
                                }
                            }
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                            localStorage.clear()
                            window.location.reload()
                        }
                    }).catch((error) => {
                        const errorresponse = error.response
                        const azureAdB2C = localStorage.getItem('azureAdB2C')
                        if (errorresponse) {
                            const status = errorresponse.status
                            if (status === 403 || status === 401) {
                                localStorage.clear()
                                window.location.reload()
                            } else if (status === 406) {
                                window.location.reload()
                            } else if (status === 412) {
                                const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                                localStorage.clear()
                                window.location.href = AzureB2CLogoutUrl
                            } else if (status === 417 || status === 424) {
                                if (count !== 2) {
                                    count = count + 1
                                }
                                if ((count + 1) === 3) {
                                    const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                                    localStorage.clear()
                                    window.location.href = AzureB2CLogoutUrl
                                }
                            } else {
                                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                                setTimeout(() => {
                                    localStorage.clear()
                                    window.location.reload()
                                }, 2000)
                            }
                        }
                    })
                }
            }
        }).catch((error) => {
            const errorresponse = error.response
            if (errorresponse) {
                const status = errorresponse.status
                if (status === 404) {
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                }
            }
        })
}

const apiCall = async (method, endpoint, data, value) => {
    const localStorageToken = localStorage.getItem('token')
    const authAxios = DefaultConfig().authAxios
    const token = getToken()
    // console.log(!token && !callUiConfiguration, !token, !callUiConfiguration)
    if (!token && !callUiConfiguration) {
        // const dispatch = useDispatch()
        callUiConfiguration = true
        console.log('Configuration data has expired')
        axios.get(`${GlobalVariable.hostpath}api/Common/GetUIConfiguration`)
            .then((res) => {
                const result = res.data
                callUiConfiguration = false
                if (result) {
                    const data = result.data
                    if (data) {
                        const azureAdB2C = data.azureAdB2C
                        const merchantOne = data.merchantOne
                        const JsScriptData = data.jsScriptData
                        azureAdB2C['apiUrl'] = GlobalVariable.hostpath
                        azureAdB2C['hostname'] = window.location.origin
                        localStorage.setItem('azureAdB2C', JSON.stringify(azureAdB2C))
                        localStorage.setItem('merchantOne', JSON.stringify(merchantOne))
                        localStorage.setItem('JsScriptData', JSON.stringify(JsScriptData))
                        const expiryTimestamp = new Date().getTime() + (data.expiryTime * 60 * 1000)
                        localStorage.setItem('tokenExpiry', expiryTimestamp)

                        axios.get(`${GlobalVariable.hostpath}api/User/GetUser`, {
                            headers: { Authorization: `Bearer ${localStorageToken}` }
                        }).then((res) => {
                            const userData = res.data
                            if (userData.success) {
                                if (userData.data) {
                                    if (window.location.hostname !== 'localhost') {
                                        const msClarityId = localStorage.getItem('JsScriptData') ? JSON.parse(localStorage.getItem('JsScriptData'))['msClarityId'] : ''
                                        clarity.init(msClarityId)
                                        clarity.identify('USER_ID', { userProperty: userData.data.email })
                                        clarity.setTag('Email', userData.data.email)
                                        clarity.consent()
                                    }
                                    if (userData.data.isResetPassword === true) {
                                        toast(t => (<ToastMessage t={t} message={"Your password has been changed successfully. Please Login..."} status={"success"} />))
                                        setTimeout(() => {
                                            localStorage.clear()
                                            window.location.reload()
                                        }, 3000)
                                    } else {
                                        const cookies = new Cookies()
                                        cookies.set('CustomClaims', res.headers["x-set-cookie"], { path: '/' })
                                        localStorage.setItem('userData', JSON.stringify(userData.data))
                                    }
                                }
                            } else {
                                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                                localStorage.clear()
                                window.location.reload()
                            }
                        }).catch((error) => {
                            const errorresponse = error.response
                            if (errorresponse) {
                                const status = errorresponse.status
                                if (status === 403 || status === 401) {
                                    localStorage.clear()
                                    window.location.reload()
                                } else if (status === 406) {
                                    // setError(true)
                                    // navigate("/Unauthorized")
                                    window.location.reload()
                                } else if (status === 412) {
                                    const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                                    localStorage.clear()
                                    window.location.href = AzureB2CLogoutUrl
                                } else if (status === 417 || status === 424) {
                                    if (count !== 2) {
                                        setCount(count + 1)
                                    }
                                    if ((count + 1) === 3) {
                                        const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                                        localStorage.clear()
                                        window.location.href = AzureB2CLogoutUrl
                                    }
                                } else {
                                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                                    setTimeout(() => {
                                        localStorage.clear()
                                        window.location.reload()
                                    }, 2000)
                                }
                            }
                        })
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 404) {
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    }
                }
            })
    }
    if (method === 'get') {
        return await authAxios.get(endpoint)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    let resData
                    if (respData.success) {
                        if (respData.data) {
                            resData = respData.data
                        } else {
                            resData = respData.errorMessage
                        }
                        return resData
                    } else {
                        if (!value) {
                            if (respData.errorMessage) {
                                toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                            } else {
                                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                            }
                            return ''
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        toast(t => (<ToastMessage t={t} message={"The system was unable to complete the process due to security restrictions. Please try again later or contact support for further assistance"} status={"danger"} />))
                        return ''
                    } else if (status === 406) {
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
                        return ''
                    } else if (status === 419) {
                        if (!getUserCall) {
                            getUserCall = true
                            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
                            return ''
                        }
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    } else if (method === 'post') {
        return await authAxios.post(endpoint, data)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        toast(t => (<ToastMessage t={t} message={"The system was unable to complete the process due to security restrictions. Please try again later or contact support for further assistance"} status={"danger"} />))
                        return ''
                    } else if (status === 406) {
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
                        return ''
                    } else if (status === 419) {
                        if (!getUserCall) {
                            getUserCall = true
                            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
                            return ''
                        }
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    } else if (method === 'patch') {
        return await authAxios.patch(endpoint, data)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        toast(t => (<ToastMessage t={t} message={"The system was unable to complete the process due to security restrictions. Please try again later or contact support for further assistance"} status={"danger"} />))
                        return ''
                    } else if (status === 406) {
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
                        return ''
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    } else if (method === 'delete') {
        return await authAxios.delete(endpoint)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        toast(t => (<ToastMessage t={t} message={"The system was unable to complete the process due to security restrictions. Please try again later or contact support for further assistance"} status={"danger"} />))
                        return ''
                    } else if (status === 406) {
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
                        return ''
                    } else if (status === 419) {
                        if (!getUserCall) {
                            getUserCall = true
                            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
                            return ''
                        }
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    }
}

const apiUpdateCall = async (method, endpoint, data, toasttype) => {
    const authAxios = DefaultConfig().authAxios
    if (method === 'post') {
        return await authAxios.post(endpoint, data)
            .then((response) => {
                const respData = response.data
                if (respData) {
                    if (respData.success) {
                        const resData = respData.data
                        if (toasttype === 'filesave') {
                            toast(t => (<ToastMessage t={t} message={"File Saved Successfully"} status={"success"} />))
                        } else if (toasttype === 'fileremove') {
                            toast(t => (<ToastMessage t={t} message={"File Removed Successfully"} status={"success"} />))
                        } else if (toasttype === 'date') {
                            toast(t => (<ToastMessage t={t} message={"Date Saved Successfully"} status={"success"} />))
                        } else if (toasttype === 'comment' && data.name !== 'ERBNDA') {
                            toast(t => (<ToastMessage t={t} message={"Comment Saved Successfully"} status={"success"} />))
                        } else if (toasttype === 'Vessel') {
                            toast(t => (<ToastMessage t={t} message={"Vessel Data Updated Successfully"} status={"success"} />))
                        } else if (toasttype === 'proFormaamt') {
                            toast(t => (<ToastMessage t={t} message={"Pro Forma Amount Updated Successfully"} status={"success"} />))
                        } else if (toasttype === 'ProuctCode') {
                            toast(t => (<ToastMessage t={t} message={"Product code Updated Successfully"} status={"success"} />))
                        } else if (toasttype === 'Yes/No') {
                            toast(t => (<ToastMessage t={t} message={"Data Saved Successfully"} status={"success"} />))
                        } else if (toasttype === 'text') {
                            toast(t => (<ToastMessage t={t} message={"Data Saved Successfully"} status={"success"} />))
                        } else if (toasttype === 'agent') {
                            toast(t => (<ToastMessage t={t} message={"Agent Type Updated Successfully"} status={"success"} />))
                        } else if (toasttype === 'agentId') {
                            toast(t => (<ToastMessage t={t} message={"Agent ID Updated Successfully"} status={"success"} />))
                        } else if (toasttype === 'country') {
                            toast(t => (<ToastMessage t={t} message={"Certificate Country Updated Successfully"} status={"success"} />))
                        } else if (toasttype === 'code') {
                            toast(t => (<ToastMessage t={t} message={"Certificate ID Updated Successfully"} status={"success"} />))
                        } else if (toasttype === 'expdate') {
                            toast(t => (<ToastMessage t={t} message={"Expiration Date Updated Successfully"} status={"success"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Work Order Updated Successfully"} status={"success"} />))
                        }
                        return resData
                    } else {
                        if (respData.errorMessage) {
                            toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
                        } else {
                            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        }
                        return ''
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        toast(t => (<ToastMessage t={t} message={"The system was unable to complete the process due to security restrictions. Please try again later or contact support for further assistance"} status={"danger"} />))
                        return ''
                    } else if (status === 406) {
                        toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
                        return ''
                    } else if (status === 419) {
                        if (!getUserCall) {
                            getUserCall = true
                            toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
                            return ''
                        }
                    } else if (status === 401) {
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        // const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                        return ''
                    }
                }
            })
    }
}

export const getRefreshToken = createAsyncThunk("appCommonReducers/getRefreshToken", async () => {
    const method = 'get'
    const endpoint = `User/GetRefreshToken`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        localStorage.setItem("token", resultData.id_token)
        localStorage.setItem("refresh_token", resultData.refresh_token)
        getUserApiCall()
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Categories
export const getWorkOrderTypesAndCategories = createAsyncThunk("appCommonReducers/getWorkOrderTypesAndCategories", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetWorkOrderTypesAndCategories
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Stages
export const getWorkorderStages = createAsyncThunk("appCommonReducers/getWorkorderStages", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetWorkorderStages
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetServiceProviderAgents = createAsyncThunk("appCommonReducers/GetServiceProviderAgents", async (code) => {
    const method = 'get'

    const endpoint = `${code.catCode}/${code.typeCode}/${ApiUrls.GetServiceProviderAgents}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const ValidatePractionerId = createAsyncThunk("appCommonReducers/ValidatePractionerId", async (code) => {

    const method = 'get'
    const endpoint = `${code.catCode}/${code.typeCode}/${ApiUrls.ValidatePractionerId}?practionerId=${code.practitionerId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetAffiliateAgents = createAsyncThunk("appCommonReducers/GetAffiliateAgents", async (code) => {
    const method = 'get'
    const endpoint = `${code.catCode}/${code.typeCode}/${ApiUrls.GetAffiliateAgents}?companyId=${code.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})


// Get Country and States
export const getCountryStates = createAsyncThunk("appCommonReducers/getCountryStates", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetCountryStates
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const countrys = []
        resultData.forEach((element) => {
            const stateArr = []
            const eleStates = element.statesList ? element.statesList : []
            eleStates.forEach((ele) => {
                stateArr.push({ value: ele.stateCode, label: ele.stateName, stateCode: ele.stateCode, stateName: ele.stateName })
            })
            countrys.push({ value: element.countryCode, label: element.countryName, states: stateArr, valueCoutry: element.country3digitCode ? element.country3digitCode : element.countryCode })
        })
        return {
            data: countrys,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Company Details
export const getCompanyDetails = createAsyncThunk("appCommonReducers/getCompanyDetails", async () => {
    const method = 'get'
    const endpoint = ApiUrls.GetCompanyDetails
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const company = []
        resultData.forEach((element) => {
            company.push({ value: element.companyId, label: element?.agentId ? `${element.agentId} - ${element.name}` : element.name, agentId: element.agentId })
        })
        return {
            data: company,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// get customer company details
export const GetCustomerCompanyDetails = createAsyncThunk("appCommonReducers/GetCustomerCompanyDetails", async () => {
    // const method = 'get'
    // const endpoint = ApiUrls.GetCustomerCompanyDetails
    // const data = ''
    // const resultData = await apiCall(method, endpoint, data)
    const userData = JSON.parse(localStorage.getItem('userData'))
    const resultData = userData?.companies
    if (resultData) {
        const company = []
        resultData.forEach((element) => {
            company.push({ value: element.agentId, label: `${element.name ? element.name : element.agentName} - ${element.agentId}`, name: element.name ? element.name : element.agentName })
        })
        return {
            data: company,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Customer Dashboard Workorders
export const getWorkorders = createAsyncThunk("appCommonReducers/getWorkorders", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.GetCustomerWorkorders
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workordersDto = resultData.workorder_DTO ? resultData.workorder_DTO : []
        const recCount = resultData.count
        const gridSize = resultData.pageSize
        return {
            data: workordersDto,
            recCount,
            gridSize,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Employee Dashboard WOrkorders based on pagination
export const getWorkordersByFilters = createAsyncThunk("appCommonReducers/getWorkordersByFilters", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.FilterWorkorders
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workordersDto = resultData.workorder_DTO ? resultData.workorder_DTO : []
        const recCount = resultData.count
        const gridSize = resultData.pageSize
        return {
            data: workordersDto,
            recCount,
            gridSize,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Employee Dashboard WOrkorders based on pagination
export const GetTotalInvoiceRevenue = createAsyncThunk("appCommonReducers/GetTotalInvoiceRevenue", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.GetTotalInvoiceRevenue
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workordersDto = resultData.invoiceData ? resultData.invoiceData : []
        const recCount = resultData.count
        const gridSize = resultData.pageSize
        const amount = resultData?.totalAmount
        return {
            data: workordersDto,
            recCount,
            amount,
            gridSize,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})


// Create Workorder Validation Checking for exist or not
export const ValidateWorkorderCreation = createAsyncThunk("appCommonReducers/ValidateWorkorderCreation", async (obj) => {
    const method = 'get'
    const endpoint = `${obj.categoryId}/${obj.type}/${ApiUrls.ValidateWorkorderCreation}?companyId=${obj.companyId ? obj.companyId : 0}`
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetUsers}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)

    if (resultData) {
        const allUsers = []
        resultData.forEach((element) => {
            allUsers.push({ userId: element.id, name: `${element.firstName} ${element.lastName}`, email: element.email, companyId: element.companyId, status: element.isActive ? 'Active' : 'InActive' })
        })
        return {
            data: allUsers,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)

    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetUsersByAgentIds = createAsyncThunk("appCommonReducers/GetUsersByAgentIds", async (obj) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetUsersByAgentIds}`
    const data = obj
    const resultData = await apiCall(method, endpoint, data)

    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetUserCompanies = createAsyncThunk("appCommonReducers/GetUserCompanies", async (obj) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetUserCompanies}?email=${obj.email}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)

    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
    const data = rdata.data
    const resultData = await apiCall(method, endpoint, data)

    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetSFRCompaniesByName = createAsyncThunk("appCommonReducers/GetSFRCompaniesByName", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetSFRCompaniesByName}/${wdata.salesforce}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetUsersBySearch = createAsyncThunk("appCommonReducers/GetUsersBySearch", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetUsersBySearch}/${wdata.value}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetCompaniesByName = createAsyncThunk("appCommonReducers/GetCompaniesByName", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCompaniesByName}/${wdata.salesforce}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetTrainingCenterAddressDetails = createAsyncThunk("appCommonReducers/GetTrainingCenterAddressDetails", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetTrainingCenterAddressDetails}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})
export const GetCADetails = createAsyncThunk("appCommonReducers/GetCADetails", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCADetails}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetTrainingDetailsByParentWorkorderId = createAsyncThunk("appCommonReducers/GetTrainingDetailsByParentWorkorderId", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetTrainingDetailsByParentWorkorderId}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetApprovedCourseDetails = createAsyncThunk("appCommonReducers/GetApprovedCourseDetails", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetApprovedCourseDetails}?trainingCenterCompanyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetApprovedInstructors = createAsyncThunk("appCommonReducers/GetApprovedInstructors", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetApprovedInstructors}?companyId=${wdata.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetApprovedCoursesAndReferences = createAsyncThunk("appCommonReducers/GetApprovedCoursesAndReferences", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetApprovedCoursesAndReferences}`
    // const endpoint = `MT/CA/${ApiUrls.GetApprovedCoursesAndReferences}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const uniqueCourses = []
        const courseMap = new Map()
        resultData.forEach(({ courseName, courseCode, id }) => {
            if (!courseMap.has(courseName)) {
                courseMap.set(courseName, {
                    value: courseName,
                    label: courseName,
                    courseId: id,
                    courseCodes: []
                })
                uniqueCourses.push(courseMap.get(courseName))
            }
            courseMap.get(courseName).courseCodes.push({ value: courseCode, label: courseCode })
        })
        uniqueCourses.forEach(course => {
            if (course.label !== 'Other') {
                course.courseCodes.push({ value: "Other", label: "Other" })
            }
        })
        return {
            data: uniqueCourses,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetCourseDetails = createAsyncThunk("appCommonReducers/GetCourseDetails", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCourseDetails}?companyId=${wdata?.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const uniqueCourses = []
        resultData.forEach((element) => {
            uniqueCourses.push({ value: element.courseName, label: element.courseName })
        })
        const unique = Array.from(new Map(uniqueCourses.map(obj => [obj.value, obj])).values())
        return {
            data: unique,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetCourseCopyForUsers = createAsyncThunk("appCommonReducers/GetCourseCopyForUsers", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCourseCopyForUsers}?userId=${wdata.userId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetUsersByEmailKeyword = createAsyncThunk("appCommonReducers/GetUsersByEmailKeyword", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetUsersByEmailKeyword}?emailKeyword=${wdata.stdValue}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetApprovedCourses = createAsyncThunk("appCommonReducers/GetApprovedCourses", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetApprovedCourses}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const allData = []
        resultData.forEach((element) => {
            allData.push({ value: element, label: element })
        })
        return {
            data: allData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GnerateInvoice = createAsyncThunk("appCommonReducers/GnerateInvoice", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GnerateInvoice}`
    const data = getData(wdata.object)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetApprovedCourseReferences = createAsyncThunk("appCommonReducers/GetApprovedCourseReferences", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetApprovedCourseReferences}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const allData = []
        resultData.forEach((element) => {
            allData.push({ value: element, label: element })
        })
        return {
            data: allData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetApprovedCapacityofCertificate = createAsyncThunk("appCommonReducers/GetApprovedCapacityofCertificate", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetApprovedCapacityofCertificate}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const allData = []
        resultData.forEach((element) => {
            allData.push({ value: element, label: element })
        })
        return {
            data: allData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const getAllInstructorDetails = createAsyncThunk("appCommonReducers/getAllInstructorDetails", async (obj) => {
    const method = 'get'
    const endpoint = `${obj.ccode}/${obj.tcode}/${ApiUrls.getAllInstructorDetails}?CompanyId=${obj?.companyId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetProductCodes = createAsyncThunk("appCommonReducers/GetProductCodes", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetProductCodes}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetSearchAgent = createAsyncThunk("appCommonReducers/GetSearchAgent", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetSearchAgent}?name=${wdata.value}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetAgentDetailsById = createAsyncThunk("appCommonReducers/GetAgentDetailsById", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetAgentDetailsById}?agentid=${wdata.value}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetSFRCompanies = createAsyncThunk("appCommonReducers/GetSFRCompanies", async (wdata) => {
    // const method = 'get'
    // const endpoint = `${ApiUrls.GetSFRCompanies}`
    // const data = ''
    // const resultData = await apiCall(method, endpoint, data)
    const userData = JSON.parse(localStorage.getItem('userData'))
    const resultData = userData?.companies
    return resultData
})

export const GetApplicationData = createAsyncThunk("appCommonReducers/GetApplicationData", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetApplicationData}?${(wdata.tcode === "RC" || wdata.tcode === "RPA" || wdata.tcode === "APR") ? "companyId" : "companyid"}=${wdata.uniqueId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetCASSupportingDocuments = createAsyncThunk("appCommonReducers/GetCASSupportingDocuments", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetCASSupportingDocuments}?filepath=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetSupportingDocuments = createAsyncThunk("appCommonReducers/GetSupportingDocuments", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetSupportingDocuments}?filepath=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})
export const SendFeedbackEmail = createAsyncThunk("appCommonReducers/SendFeedbackEmail", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.SendFeedbackEmail}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
        return resultData
    }
})

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
    return displayMenuBool
})

export const updateDirtyBool = createAsyncThunk("appCommonReducers/updateDirtyBool", async (dirtyValue) => {
    return dirtyValue
})

export const timeCheck = createAsyncThunk("appCommonReducers/timeCheck", async (dirtyValue) => {
    return dirtyValue || false
})

export const GetQuestions = createAsyncThunk("appCommonReducers/GetQuestions", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetQuestions}?typeId=${wdata?.type}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetCasAgreemet = createAsyncThunk("appCommonReducers/GetCasAgreemet", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCasAgreemet}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetRcaAgreement = createAsyncThunk("appCommonReducers/GetRcaAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetRcaAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetAffAgreement = createAsyncThunk("appCommonReducers/GetAffAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAffAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetFamAgreement = createAsyncThunk("appCommonReducers/GetFamAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetFamAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetAgreement = createAsyncThunk("appCommonReducers/GetAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetTCAAgreement = createAsyncThunk("appCommonReducers/GetTCAAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetTCAAgreement}/?woId=${wdata.file}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const RefreshVesselData = createAsyncThunk("appCommonReducers/RefreshVesselData", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RefreshVesselData}?woId=${wdata.woid}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetVesslesByAgentId = createAsyncThunk("appCommonReducers/GetVesslesByAgentId", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesslesByAgentId}?agentId=${wdata.AgentNumber}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetUsersByAgentId = createAsyncThunk("appCommonReducers/GetUsersByAgentId", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetUsersByAgentId}?agentId=${wdata.AgentNumber}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const RefreshScdUsers = createAsyncThunk("appCommonReducers/RefreshScdUsers", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RefreshScdUsers}?woId=${wdata.woid}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const SEAPortalRevenuesDownloadExcel = createAsyncThunk("appCommonReducers/SEAPortalRevenuesDownloadExcel", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.SEAPortalRevenuesDownloadExcel}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetInvoiceLoader = createAsyncThunk("appCommonReducers/GetInvoiceLoader", async (wdata) => {
    return false
})

export const GetUserLoader = createAsyncThunk("appCommonReducers/GetUserLoader", async (wdata) => {
    return true
})

export const GetSearchclinicAgent = createAsyncThunk("appCommonReducers/GetSearchclinicAgent", async () => {
    const data = [{ value: 'Other', label: 'Other' }]
    return data
})

// Get Base Workorder Data
export const getBaseWorkorderData = createAsyncThunk("appCommonReducers/getBaseWorkorderData", async (wdata) => {
    if (wdata.value === 'ena') {
        const method = 'get'
        const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetBaseWorkOrderData}`
        const data = ''
        const resultData = await apiCall(method, endpoint, data)
        if (resultData) {
            return {
                data: resultData,
                spinner: true,
                tokenExp: false
            }
        } else {
            return {
                data: null,
                spinner: true,
                tokenExp: false
            }
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Agent Information Data
export const getAgentInformationnData = createAsyncThunk("appCommonReducers/getAgentInformationnData", async (wdata) => {

    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAgentInformationnData}?companyId=${wdata.agentId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Get Template Workorder Data
export const getDocumentTemplateData = createAsyncThunk("appCommonReducers/getDocumentTemplateData", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetDocumentTemplateData}?documentId=${wdata.documentId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    } else {
        return {
            data: null,
            spinner: true,
            tokenExp: false,
            reqData: wdata
        }
    }
})

// Create workorder
export const CreateWorkorder = createAsyncThunk("appCommonReducers/CreateWorkorder", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.CreateWorkorder}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const saveCSVRCWDocument = createAsyncThunk("appCommonReducers/saveCSVRCWDocument", async (wdata) => {
    const values = wdata.fileData
    if (values.fileDto.length > 0) {
        const formData = new FormData()
        formData.append("file", values.fileDto[0].file)
        const woType = values.fileDto[0].type
        const method = 'post'
        const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateCodesDetails}?woId=${values.woId}&agentId=${wdata.agntId}`
        const data = formData
        const resultData = await apiCall(method, endpoint, data)
        if (resultData) {
            return {
                data: resultData,
                spinner: true,
                tokenExp: false,
                woType,
                woTypeId: values.woId,
                stype: values.stype,
                errorMsg: ''
            }
        }
    }
})

export const FilterCodes = createAsyncThunk("appCommonReducers/FilterCodes", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.FilterCodes}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Workorder Data
export const getWorkordersData = createAsyncThunk("appCommonReducers/getWorkordersData", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetWorkorderById}?id=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Workorder Json Data
export const updateWoData = createAsyncThunk("appCommonReducers/updateWoData", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateWorkorderData}?woId=${wdata.woData.id}`
    const data = getData(wdata.woData)
    const type = wdata.type
    const resultData = await apiUpdateCall(method, endpoint, data, type)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const AddorRemoveProformaInvoice = createAsyncThunk("appCommonReducers/AddorRemoveProformaInvoice", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.AddorRemoveProformaInvoice}?woId=${wdata.id}&isAdd=${wdata.isAdd}&amount=${wdata.amount}`
    const data = ''
    const type = wdata.type
    const resultData = await apiUpdateCall(method, endpoint, data, type)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateProductCodes = createAsyncThunk("appCommonReducers/UpdateProductCodes", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateProductCodes}`
    const obj = {}
    obj.invoiceId = wdata.invoiceId ? wdata.invoiceId : null
    obj.WoId = wdata.id
    obj.Products_DTO = wdata.list
    const data = obj
    const type = wdata.type
    const resultData = await apiUpdateCall(method, endpoint, data, type)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateProformaInvoice = createAsyncThunk("appCommonReducers/UpdateProformaInvoice", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateProformaInvoice}?woId=${wdata.id}&amount=${wdata.amount}`
    const obj = {}
    const data = obj
    const type = wdata.type
    const resultData = await apiUpdateCall(method, endpoint, data, type)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateNdaDocument = createAsyncThunk("appCommonReducers/UpdateNdaDocument", async (wdata) => {
    const method = 'patch'
    // const endpoint = `${ApiUrls.UpdateNdaDocument}?woId=${values.woId}&fileId=${values.fileId}`
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateNdaDocument}?woId=${wdata.woId}&fileId=${wdata.fileId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})
export const UpdateUserCompanyMapping = createAsyncThunk("appCommonReducers/UpdateUserCompanyMapping", async (wdata) => {
    const method = 'patch'
    const endpoint = `${ApiUrls.UpdateUserCompanyMapping}`
    const data = wdata?.removingData
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

// sea system refresh data
export const RetryAddAgentContact = createAsyncThunk("appCommonReducers/RetryAddAgentContact", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RetryAddAgentContact}?firstName=${wdata.failedlist.firstName}&lastName=${wdata.failedlist.lastName}&email=${wdata.failedlist.email}&userName=${wdata.failedlist.userName}&isClientAdmin=${wdata.failedlist.isClientAdmin}`
    const data = wdata.workorderData
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const RefreshSeaData = createAsyncThunk("appCommonReducers/RefreshSeaData", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RefreshSeaData}`
    const data = wdata.retrySCDUser_DTO
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Workorder Data
export const UpdateWorkorder = createAsyncThunk("appCommonReducers/UpdateWorkorder", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateWorkorder}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateAgentDetails = createAsyncThunk("appCommonReducers/UpdateAgentDetails", async (wdata) => {
    const method = 'post'
    const endpoint = `FA/AA/UpdateAgentDetails`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const applicationDataBinding = createAsyncThunk("appCommonReducers/applicationDataBinding", async (wdata) => {
    return wdata
})

export const AcceptProofOfAffliationDoc = createAsyncThunk("appCommonReducers/AcceptProofOfAffliationDoc", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.AcceptProofOfAffliationDoc}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (!resultData?.workorderValidationMessage) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            spinner: true,
            tokenExp: false,
            dt: resultData
        }
    }
})

export const CompareAffiliateDetailsWithScd = createAsyncThunk("appCommonReducers/CompareAffiliateDetailsWithScd", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.CompareAffiliateDetailsWithScd}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return resultData
    }
})

export const SyncAffiliateDetailsWithSCD = createAsyncThunk("appCommonReducers/SyncAffiliateDetailsWithSCD", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.SyncAffiliateDetailsWithSCD}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update RequestMoreInfo Data
export const UpdateIsNeedMoreInfo = createAsyncThunk("appCommonReducers/UpdateIsNeedMoreInfo", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RequestMoreInfo}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const RejectProofOfAffliationDoc = createAsyncThunk("appCommonReducers/RejectProofOfAffliationDoc", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RejectProofOfAffliationDoc}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const RejectWorkOrder = createAsyncThunk("appCommonReducers/RejectWorkOrder", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RejectWorkOrder}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// CreateQuestionResponse for CSA Work Order
export const CreateQuestionResponse = createAsyncThunk("appCommonReducers/CreateQuestionResponse", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.CreateQuestionResponse}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const UpdateQuestionResponse = createAsyncThunk("appCommonReducers/UpdateQuestionResponse", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.UpdateQuestionResponse}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return resultData

    }
})

export const CreateUserCompanyMapping = createAsyncThunk("appCommonReducers/CreateUserCompanyMapping", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.CreateUserCompanyMapping}`
    const data = wdata.data
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return resultData
    }
})

// Update UpdateNeedMoreInfoStatus Data
export const UpdateNeedMoreInfoStatus = createAsyncThunk("appCommonReducers/UpdateNeedMoreInfoStatus", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateNeedMoreInfoStatus}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// // Cancel Workorder
// export const CancelWorkorder = createAsyncThunk("appCommonReducers/CancelWorkorder", async (wdata) => {
//     const method = 'get'
//     const endpoint = `${wdata.ccode}/${wdata.tcode}/${wdata.modalName === 'Cancel' ? ApiUrls.CancelWorkorder : ApiUrls.ArchivedWorkorder}?companyId=${wdata.comId}&woId=${wdata.woId}`
//     const data = ''
//     const resultData = await apiCall(method, endpoint, data)
//     if (resultData) {
//         const workorderData = resultData.workorderData
//         return {
//             data: workorderData,
//             data1: resultData,
//             spinner: true,
//             tokenExp: false
//         }
//     }
// })

// Cancel Workorder
export const CancelWorkorder = createAsyncThunk("appCommonReducers/CancelWorkorder", async (wdata) => {
    const method = 'get'
    let dynamicUrl = ''
    if (wdata.modalName === 'Cancel') {
        dynamicUrl = ApiUrls.CancelWorkorder
    } else if (wdata.modalName === 'Archive') {
        dynamicUrl = ApiUrls.ArchivedWorkorder
    } else if (wdata.modalName === 'Suspend') {
        dynamicUrl = ApiUrls.SuspendWorkorder
    }
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${dynamicUrl}?companyId=${wdata.comId}&woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Resend Docusign Email
export const ResendDocusignEmail = createAsyncThunk("appCommonReducers/ResendDocusignEmail", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ResendDocusignEmail}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const ValidateCode = createAsyncThunk("appCommonReducers/ValidateCode", async (codesData) => {
    const method = 'get'
    const endpoint = `${ApiUrls.ValidateCode}?Code=${codesData}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)

    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Invoice Document
export const GetInvoiceDocument = createAsyncThunk("appCommonReducers/GetInvoiceDocument", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetInvoiceDocument}?invoiceId=${wdata.invoiceId}&woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetCCGPreviewAgreement = createAsyncThunk("appCommonReducers/GetCCGPreviewAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCCGPreviewAgreement}?woid=${wdata.woId}&userEmail=${wdata.email}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetCCGCOPYAgreement = createAsyncThunk("appCommonReducers/GetCCGCOPYAgreement", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCCGCOPYAgreement}?woid=${wdata.woId}&userEmail=${wdata.email}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// get ProForma Invoice and Filing Agent invoice documnet in cas Workorder
export const GetcasInvoiceDocument = createAsyncThunk("appCommonReducers/GetcasInvoiceDocument", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetcasInvoiceDocument}?invoiceId=${wdata.invoiceId}&woId=${wdata.woId}&isProforma=${wdata.isProforma}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetRcaInvoiceDocument = createAsyncThunk("appCommonReducers/GetRcaInvoiceDocument", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetRcaInvoiceDocument}?invoiceId=${wdata.invoiceId}&woId=${wdata.woId}&isProforma=${wdata.isProforma}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetFaaInvoiceDocument = createAsyncThunk("appCommonReducers/GetFaaInvoiceDocument", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetFaaInvoiceDocument}?invoiceId=${wdata.invoiceId}&woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetTrainingCenterEmails = createAsyncThunk("appCommonReducers/GetTrainingCenterEmails", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetTrainingCenterEmails}?companyId=${wdata.id}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetCrewsList = createAsyncThunk("appCommonReducers/GetCrewsList", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCrewsList}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const crew = []
        resultData.forEach((element) => {
            if (element?.fin) crew.push({ value: element?.fin, label: element?.fin ? `${element?.firstName} - ${element.lastName} - ${element?.fin}` : `${element?.firstName} - ${element.lastName}`, companyId: element?.companyId, id: element?.id })
        })
        return {
            data: crew,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
    // if (resultData) {
    //     return {
    //         data: resultData,
    //         spinner: true,
    //         tokenExp: false
    //     }
    // }
})

export const GetCrewDetailsByFinId = createAsyncThunk("appCommonReducers/GetCrewDetailsByFinId", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCrewDetailsByFinId}?finId=${wdata.id}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get download file
export const DownloadFile = createAsyncThunk("appCommonReducers/DownloadFile", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.DownloadFile}?fileId=${wdata.fileId}&imoNumber=${wdata.imoNumber}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Get Preview Document
export const GetPreviewDocument = createAsyncThunk("appCommonReducers/GetPreviewDocument", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetPreviewDocument}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// start workorder omments
export const getWorkordersByIdComments = createAsyncThunk("appCommonReducers/getWorkordersByIdComments", async (woId) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetWorkorderComments}?woId=${woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Create Workorder Comment
export const createWorkOrderComment = createAsyncThunk("appCommonReducers/createWorkOrderComment", async (obj) => {
    const method = 'post'
    const endpoint = `${ApiUrls.CreateComment}`
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false,
            needstatus: obj.status,
            needcomment: obj.comment
        }
    }
})
// end workorder omments


// Update Billing Prefix Workorder
export const UpdateBillingPrefix = createAsyncThunk("appCommonReducers/UpdateBillingPrefix", async (wdata) => {
    const method = 'patch'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateBillingPrefix}?woId=${wdata.woId}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={"Billing Prefix Updated Successfully"} status={"success"} />))
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Resend Email Workorder
export const UpdateResendEmail = createAsyncThunk("appCommonReducers/UpdateResendEmail", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateResendEmail}?woId=${wdata.woId}`
    const data = wdata.obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={"Resend Email Successfully"} status={"success"} />))
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

// Update Billing Prefix Workorder
export const RegenerateAuthorizationLetter = createAsyncThunk("appCommonReducers/RegenerateAuthorizationLetter", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${(wdata.tcode === "PEC" || wdata.tcode === "MCG") ? "RegenerateCertificate" : ApiUrls.RegenerateAuthorizationLetter}?woId=${wdata.woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        toast(t => (<ToastMessage t={t} message={wdata?.status === 5 ? "Document Regenerated Successfully" : "Certificate Regenerated Successfully"} status={"success"} />))
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getWorkordersById = createAsyncThunk("appCommonReducers/getWorkordersById", async (woId) => {
    const authAxios = DefaultConfig().authAxios
    const resultData = await authAxios.get(`GetWorkOrderById/${woId}`)
        .then((response) => {
            const respData = response.data
            if (respData) {
                if (respData.success) {
                    const resData = respData.data
                    if (resData) {
                        return {
                            data: resData,
                            spinner: true,
                            tokenExp: false
                        }
                    }
                } else {
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: true,
                        tokenExp: false
                    }
                }
            }
        }).catch((error) => {
            const errorresponse = error.response
            if (errorresponse) {
                const status = errorresponse.status
                if (status === 403) {
                    toast(t => (<ToastMessage t={t} message={"The system was unable to complete the process due to security restrictions. Please try again later or contact support for further assistance"} status={"danger"} />))
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: true
                    }
                } else if (status === 401) {
                    localStorage.clear()
                    window.location.reload()
                } else {
                    // const error = errorresponse.data.error
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                    return {
                        data: [],
                        spinner: false,
                        tokenExp: false
                    }
                }
            }
        })
    return resultData
})

// Start File Upload, download and remove files
export const getUpdateFileData = createAsyncThunk("appCommonReducers/getUpdateFileData", async (newObj) => {
    return newObj
})

export const getUpdateFileDataFolder = createAsyncThunk("appCommonReducers/getUpdateFileDataFolder", async (newObj) => {
    return newObj
})

export const uploadCompleted = createAsyncThunk("appCommonReducers/uploadCompleted", async ({ blocksData, values }, thunkAPI) => {
    try {
        const headers1 = {
            "X-File-Name": values['filename'],
            "X-WO-ID": values['woId'],
            "X-DocumentType": values.fileDto[0].documentType,
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
        if (values.fileDto[0]?.fileIdExist) {
            headers1["X-File-FileId"] = values.fileDto[0].fileIdExist
        }
        const authAxios = axios.create({
            baseURL: baseApiUrl,
            headers: headers1,
            withCredentials: true
        })
        const response = await authAxios.post(`FileUpload/CompleteUpload`, blocksData)
        const resData = response.data
        if (resData.success) {
            const fileData = resData.data
            fileData['doumentType'] = values.fileDto[0].documentType
            fileData['uploadName'] = values.fileDto[0]?.uploadName
            const newObj = {}
            newObj['floader'] = true
            newObj['tokenExp'] = false
            newObj['fileData'] = resData.data
            newObj['woType'] = values.fileDto[0].type
            newObj['woTypeId'] = values.woId
            newObj['stype'] = values.stype

            newObj['beginingOfTheChunk'] = 0
            newObj['endOfTheChunk'] = chunkSize
            newObj['blockData'] = []
            return newObj
        } else {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    } catch (error) {
        thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }
})

export const FileUploadChunks = createAsyncThunk("appCommonReducers/FileUploadChunks", async (values, thunkAPI) => {
    if (values.fileDto.length > 0) {
        const chunk = values['_file'].slice(values.beginingOfTheChunk, values.endOfTheChunk)
        try {
            let parseData = null
            if (values.fileDto[0]?.parse) {
                const headers1 = {
                    "X-Total-Chunks": values['chunkCount'],
                    "X-Chunk-Number": values['counter'],
                    "X-File-Name": myEncodeURIComponent(values['filename']),
                    "X-File-Size": values['fileSize'],
                    "X-Chunk-Size": values['chunkSize'],
                    "X-AgentId": values["agentId"],
                    "X-WO-ID": values['woId'],
                    "X-Vault": values?.IsVaultUpload ? values?.IsVaultUpload : false,
                    "X-DocumentSubType": values?.subDocType ? values?.subDocType : "",
                    "X-DocumentType": values.fileDto[0].parse,
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
                if (values.fileDto[0]?.fileIdExist) {
                    headers1["X-File-FileId"] = values.fileDto[0].fileIdExist
                }
                const authAxios = axios.create({
                    baseURL: baseApiUrl,
                    // headers: {
                    //   "X-Total-Chunks": values['chunkCount'],
                    //   "X-Chunk-Number": values['counter'],
                    //   "X-File-Name": myEncodeURIComponent(values['filename']),

                    //   "X-File-Size": values['fileSize'],
                    //   "X-Chunk-Size": values['chunkSize'],
                    //   "X-WO-ID": values['woId'],
                    //   "X-DocumentType": values.fileDto[0]?.parse,
                    //   "X-File-FileId": values.fileDto[0]?.fileIdExist,
                    //   Authorization: `Bearer ${localStorage.getItem('token')}`
                    // },
                    headers: headers1,
                    withCredentials: true
                })
                const responseParse = await authAxios.post(`FileUpload/ParseDocument`, chunk)
                if (responseParse?.data) {
                    parseData = responseParse?.data?.data
                }
            }
            const headers1 = {
                "X-Total-Chunks": values['chunkCount'],
                "X-Chunk-Number": values['counter'],
                "X-File-Name": myEncodeURIComponent(values['filename']),
                "X-File-Size": values['fileSize'],
                "X-Chunk-Size": values['chunkSize'],
                "X-AgentId": values["agentId"],
                "X-WO-ID": values['woId'],
                "X-Vault": values?.IsVaultUpload ? values?.IsVaultUpload : false,
                "X-DocumentSubType": values?.subDocType ? values?.subDocType : "",
                "X-DocumentType": values.fileDto[0].documentType,
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
            if (values.fileDto[0]?.fileIdExist) {
                headers1["X-File-FileId"] = values.fileDto[0].fileIdExist
            }

            const authAxios = axios.create({
                baseURL: baseApiUrl,
                headers: headers1,
                withCredentials: true
            })
            const response = await authAxios.post(`FileUpload/FileUploadChunks`, chunk)
            const respdata = response.data
            if (respdata.success) {
                if (respdata.errorMessage) {
                    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
                    toast(t => (<ToastMessage t={t} message={respdata.errorMessage} status={"danger"} />))
                    return ''
                } else {
                    if (values['counter'] === values['chunkCount']) {
                        const blocksData = values.blockData
                        blocksData.push(respdata.data.blockId)
                        if (respdata.data?.blockId) {
                            const respayload = await thunkAPI.dispatch(uploadCompleted({ blocksData, values }))
                            const uploadedData = respayload.payload
                            uploadCompleted['parseData'] = parseData
                            return uploadedData
                        } else {
                            const newObj = {}
                            const fileData = respdata.data
                            fileData['doumentType'] = values.fileDto[0].documentType
                            fileData['uploadName'] = values.fileDto[0]?.uploadName
                            newObj['floader'] = true
                            newObj['tokenExp'] = false
                            newObj['fileData'] = fileData
                            newObj['woType'] = values.fileDto[0].type
                            newObj['woTypeId'] = values.woId
                            newObj['stype'] = values.stype

                            newObj['beginingOfTheChunk'] = 0
                            newObj['endOfTheChunk'] = values['chunkSize']
                            newObj['blockData'] = []
                            newObj['parseData'] = parseData
                            return newObj
                        }
                    } else {
                        const blocksData = values.blockData
                        blocksData.push(respdata.data.blockId)
                        const beginingOfTheChunk = values['endOfTheChunk']
                        const endOfTheChunk = values['endOfTheChunk'] + values['chunkSize']
                        const newObj = {}
                        newObj['beginingOfTheChunk'] = beginingOfTheChunk
                        newObj['endOfTheChunk'] = endOfTheChunk
                        newObj['blockData'] = blocksData
                        return newObj
                    }
                }
            } else {
                thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                return ''
            }
        } catch (error) {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
        }
    }
})

export const saveFileUploads = createAsyncThunk("appCommonReducers/saveFileUploads", async (values, thunkAPI) => {
    if (values.fileDto.length > 0) {
        const _file = values.fileDto[0].file
        if (_file.size > 0 && _file.size <= 1048576 * 1024) {
            const chunkCount = _file.size % chunkSize === 0 ? _file.size / chunkSize : Math.floor(_file.size / chunkSize) + 1
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            const fileSize = _file.size

            let filename = ''
            if (values?.newList) {
                // const extension = _file.name.split('.').pop()
                // const baseName = _file.name.replace(`.${extension}`, '')

                // let counter = 1
                // let newFilename = _file.name

                // // Loop to check for duplicates and increment the filename if found
                // const newList = values?.newList
                // console.log(newList)
                // for (let i = 0; i < newList.length; i++) {
                //     const element = {...newList[i]}
                //     const extension1 = element.fileName.split('.').pop()
                //     const baseName1 = element.fileName.replace(`.${extension1}`, '')
                //     if (baseName === baseName1) {
                //         counter++
                //         console.log(baseName, counter)
                //         newFilename = `${baseName}-${counter}.${extension}`
                //     }
                // }

                // while (newList.some(file => file.fileName.replace(`.${file.fileName.split('.').pop()}`, '') === baseName)) {
                //     counter++
                //     newFilename = `${baseName}-${counter}.${extension}`
                // }

                const newList = values?.newList
                const newFileName = _file.name

                const nameParts = newFileName.split('.') // Split filename and extension
                const baseName = nameParts.slice(0, -1).join('.') // Filename without extension
                const extension = nameParts.length > 1 ? `.${nameParts[nameParts.length - 1]}` : '' // Extension with the dot

                let counter = 0
                let fileExists = true
                let finalFileName = newFileName

                const getBaseName = (fileName) => {
                    return fileName.split('.').slice(0, -1).join('.')
                }

                const fileExistsInArray = (filename) => {
                    const extension = filename.split('.').pop()
                    const baseName = filename.replace(`.${extension}`, '')
                    return newList.some(file => getBaseName(file.fileName) === baseName)
                }

                while (fileExists) {
                    if (counter === 0) {
                        finalFileName = `${baseName}${extension}` // Original filename on the first iteration
                    } else {
                        finalFileName = `${baseName}_${counter}${extension}` // Append the counter before the extension
                    }

                    if (!fileExistsInArray(finalFileName)) {
                        fileExists = false // Exit the loop when a unique filename is found
                    } else {
                        counter++ // Increment counter if the file exists
                    }
                }

                filename = finalFileName
            } else {
                filename = _file.name
            }

            // const fileExtension = _file.name.substring(_file.name.lastIndexOf('.'))
            // const baseName = _file.name.substring(0, _file.name.lastIndexOf('.'))
            // const randomId = Math.floor(Math.random() * 100000)
            // const newFileName = `${baseName}_${randomId}${fileExtension}`

            // const filename = _file.name

            values['chunkSize'] = chunkSize
            values['_file'] = _file
            values['chunkCount'] = chunkCount
            values['fileSize'] = fileSize
            values['filename'] = myEncodeURIComponent(filename)

            values['beginingOfTheChunk'] = 0
            values['endOfTheChunk'] = chunkSize
            values['blockData'] = []

            for (let i = 0; i < chunkCount; i++) {
                values['counter'] = i + 1
                const respayload = await thunkAPI.dispatch(FileUploadChunks(values))
                const fileUploadData = respayload.payload
                if ((i + 1) === chunkCount) {
                    if (fileUploadData) {
                        thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
                        return {
                            data: fileUploadData.fileData,
                            spinner: fileUploadData.floader,
                            tokenExp: fileUploadData.tokenExp,
                            woType: fileUploadData.woType,
                            woTypeId: fileUploadData.woTypeId,
                            stype: fileUploadData.stype,
                            parseData: fileUploadData.parseData,
                            type: values['type']
                        }
                    } else {
                        break
                    }
                } else {
                    if (fileUploadData) {
                        thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
                        values['beginingOfTheChunk'] = fileUploadData.beginingOfTheChunk
                        values['endOfTheChunk'] = fileUploadData.endOfTheChunk
                        values['blockData'] = fileUploadData.blockData
                    } else {
                        break
                    }
                }
            }
        } else {
            if (_file.size <= 0) {
                toast(t => (<ToastMessage t={t} message={"Please upload file more than 0 KB"} status={"danger"} />))
            } else {
                toast(t => (<ToastMessage t={t} message={"FIle upload does not exceed more than 1 GB"} status={"danger"} />))
            }
        }
    }
})

const sanitizeHeaderValue = (value) => {
    return value?.replace(/[^\x00-\xFF]/g, '')
}

export const uploadCompletedFolder = createAsyncThunk(
    "appCommonReducers/uploadCompletedFolder",
    async ({ blocksData, values }, thunkAPI) => {
        try {
            const authAxios = axios.create({
                baseURL: baseApiUrl,
                headers: {
                    "X-File-Name": sanitizeHeaderValue(values.filename),
                    "X-WO-ID": (values.woId),
                    "X-DocumentType": sanitizeHeaderValue(values.fileDto[0].documentType),
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                },
                withCredentials: true
            })
            const response = await authAxios.post(`FileUpload/CompleteUpload`, blocksData)
            const resData = response.data
            if (resData.success) {
                return {
                    floader: true,
                    tokenExp: false,
                    fileData: resData.data,
                    woType: values.fileDto[0].type,
                    woTypeId: values.woId,
                    stype: values.stype,
                    beginingOfTheChunk: 0,
                    endOfTheChunk: chunkSize,
                    blockData: []
                }
            } else {
                const updatedTotalFileCount = [...values.totalfilecount]
                updatedTotalFileCount[values.fileCount - 1] = {
                    ...updatedTotalFileCount[values.fileCount - 1],
                    counter: 0,
                    total: 0,
                    status: 'Failed'
                }
                thunkAPI.dispatch(getUpdateFileDataFolder({ progress: true, totalfilecount: updatedTotalFileCount, uploadedCount: values.fileCount }))
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
        } catch (error) {
            const updatedTotalFileCount = [...values.totalfilecount]
            updatedTotalFileCount[values.fileCount - 1] = {
                ...updatedTotalFileCount[values.fileCount - 1],
                counter: 0,
                total: 0,
                status: 'Failed'
            }
            thunkAPI.dispatch(getUpdateFileDataFolder({ progress: true, totalfilecount: updatedTotalFileCount, uploadedCount: values.fileCount }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    }
)

// Thunk to upload file chunks
export const FileUploadChunksFolder = createAsyncThunk(
    "appCommonReducers/FileUploadChunksFolder",
    async (values, thunkAPI) => {
        if (values.fileDto.length > 0) {
            const chunk = values._file.slice(values.beginingOfTheChunk, values.endOfTheChunk)
            try {
                const authAxios = axios.create({
                    baseURL: baseApiUrl,
                    headers: {
                        "X-Total-Chunks": sanitizeHeaderValue(values.chunkCount.toString()),
                        "X-Chunk-Number": sanitizeHeaderValue(values.counter.toString()),
                        "X-File-Name": sanitizeHeaderValue(values.filename),
                        "X-File-Size": sanitizeHeaderValue(values.fileSize.toString()),
                        "X-Chunk-Size": sanitizeHeaderValue(values.chunkSize.toString()),
                        "X-WO-ID": values.woId,
                        "X-DocumentType": sanitizeHeaderValue(values.fileDto[0].documentType),
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    },
                    withCredentials: true
                })
                const response = await authAxios.post(`FileUpload/FileUploadChunks`, chunk)
                const respdata = response.data
                if (respdata.success) {
                    let blocksData = []
                    if (respdata.data.blockId) {

                    } else {
                        blocksData = [...values.blockData, respdata.data]
                    }
                    blocksData.push(respdata.data.blockId)
                    if (values.counter === values.chunkCount) {
                        if (respdata.data?.blockId) {
                            const respayload = await thunkAPI.dispatch(uploadCompletedFolder({ blocksData, values }))
                            return respayload.payload
                        } else {
                            const newObj = {}
                            const fileData = respdata.data
                            fileData['doumentType'] = values.fileDto[0].documentType
                            newObj['floader'] = true
                            newObj['tokenExp'] = false
                            newObj['fileData'] = fileData
                            newObj['woType'] = values.fileDto[0].type
                            newObj['woTypeId'] = values.woId
                            newObj['stype'] = values.stype
                            newObj['beginingOfTheChunk'] = 0
                            newObj['endOfTheChunk'] = values['chunkSize']
                            newObj['blockData'] = []
                            return newObj
                        }
                    } else {
                        return {
                            beginingOfTheChunk: values.endOfTheChunk,
                            endOfTheChunk: values.endOfTheChunk + values.chunkSize,
                            blockData: blocksData
                        }
                    }
                } else {
                    const updatedTotalFileCount = [...values.totalfilecount]
                    updatedTotalFileCount[values.fileCount - 1] = {
                        ...updatedTotalFileCount[values.fileCount - 1],
                        counter: 0,
                        total: 0,
                        status: 'Failed'
                    }
                    thunkAPI.dispatch(getUpdateFileDataFolder({ progress: true, totalfilecount: updatedTotalFileCount, uploadedCount: values.fileCount }))
                    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                }
            } catch (error) {
                const updatedTotalFileCount = [...values.totalfilecount]
                updatedTotalFileCount[values.fileCount - 1] = {
                    ...updatedTotalFileCount[values.fileCount - 1],
                    counter: 0,
                    total: 0,
                    status: 'Failed'
                }
                thunkAPI.dispatch(getUpdateFileDataFolder({ progress: true, totalfilecount: updatedTotalFileCount, uploadedCount: values.fileCount }))
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
        }
    }
)

// Thunk to upload file in chunks
export const saveFileUploadsFolder = createAsyncThunk("appCommonReducers/saveFileUploadsFolder", async (values, thunkAPI) => {
    const { filesDataFolder } = values
    let totalfilecount = values['totalfilecount']

    for (let index = 0; index < filesDataFolder.length; index++) {
        const file = filesDataFolder[index]

        if (file.size > 1048576 * 1024) {
            toast(t => (<ToastMessage t={t} message={"File upload does not exceed more than 1 GB"} status={"danger"} />))
            continue
        }

        const chunkCount = Math.ceil(file.size / chunkSize)
        const filename = `${values.path}/${file.path}`

        let beginingOfTheChunk = 0
        let endOfTheChunk = chunkSize
        let blockData = []
        // const newTotalFileCount = [...totalfilecount]
        totalfilecount[index] = {
            ...totalfilecount[index],
            status: 'In Progress'
        }
        thunkAPI.dispatch(getUpdateFileDataFolder({ progress: true, totalfilecount, uploadedCount: index }))

        for (let i = 0; i < chunkCount; i++) {
            const chunk = file.slice(beginingOfTheChunk, endOfTheChunk)

            try {
                const response = await thunkAPI.dispatch(FileUploadChunksFolder({
                    fileDto: [{ file: chunk }],
                    chunkSize,
                    _file: file,
                    chunkCount,
                    fileSize: file.size,
                    filename,
                    beginingOfTheChunk,
                    endOfTheChunk,
                    blockData,
                    counter: i + 1,
                    woId: values.woId,
                    totalfilecount,
                    fileCount: index + 1
                }))

                const fileUploadData = response.payload

                if (!fileUploadData) {
                    const newTotalFileCount = [...totalfilecount]
                    newTotalFileCount[index] = {
                        ...newTotalFileCount[index],
                        counter: i + 1,
                        total: chunkCount,
                        status: 'Failed'
                    }
                }

                beginingOfTheChunk = fileUploadData.beginingOfTheChunk
                endOfTheChunk = fileUploadData.endOfTheChunk
                blockData = fileUploadData.blockData

                const newTotalFileCount = [...totalfilecount]
                newTotalFileCount[index] = {
                    ...newTotalFileCount[index],
                    counter: i + 1,
                    total: chunkCount,
                    status: (i + 1 === chunkCount) ? 'Success' : 'In Progress'
                }
                totalfilecount = newTotalFileCount
                thunkAPI.dispatch(getUpdateFileDataFolder({ progress: true, totalfilecount: newTotalFileCount, uploadedCount: index }))
                if ((filesDataFolder.length === index + 1) && (i + 1 === chunkCount)) {
                    const hasFalse = newTotalFileCount.some(obj => obj.status === 'Failed' || obj.status === 'In Progress' || obj.status === 'Pending')
                    setTimeout(() => {
                        thunkAPI.dispatch(getUpdateFileDataFolder({ progress: hasFalse, totalfilecount: newTotalFileCount, uploadedCount: index }))
                    }, 2000)
                }

                // if (i + 1 === chunkCount) {
                //     console.log('File upload completed successfully.')
                // }

            } catch (error) {
                // console.error('Error uploading file:', error)
                const newTotalFileCount = [...totalfilecount]
                newTotalFileCount[index] = {
                    ...newTotalFileCount[index],
                    status: 'Failed'
                }
                totalfilecount = newTotalFileCount
                thunkAPI.dispatch(getUpdateFileDataFolder({ progress: true, totalfilecount: newTotalFileCount, uploadedCount: index }))
                break
            }
        }
    }
}
)

export const getInvoiceFileData = createAsyncThunk("appCommonReducers/getInvoiceFileData", async (fileId) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetWorkOrderFilesByFileId}?fileId=${fileId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const CheckCodes = createAsyncThunk("appCommonReducers/CheckCodes", async (data) => {
    const method = 'post'
    const endpoint = `${ApiUrls.CheckCodes}`
    //  const data = data
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetFilesDataByFolderName = createAsyncThunk("appCommonReducers/GetFilesDataByFolderName", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.GetFilesDataByFolderName
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const DownloadDocument = createAsyncThunk("appCommonReducers/DownloadDocument", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.DownloadDocument
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const DeleteDocument = createAsyncThunk("appCommonReducers/DeleteDocument", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.DeleteDocument
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const downloadChunk = createAsyncThunk("appCommonReducers/downloadChunk", async (values, thunkAPI) => {
    try {
        const authAxios = axios.create({
            baseURL: baseApiUrl,
            headers: {
                "Content-Range": `bytes ${values.offset}-${values.end}/${values.totalSize}`,
                Authorization: `Bearer ${localStorage.getItem('token')}`
            },
            withCredentials: true
        })
        const response = await authAxios.get(`FileUpload/GetFileContentByFileId?fileId=${values['fileId']}`)
        const resData = response.data
        if (resData.success) {
            const respData = resData.data
            return respData
        } else {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    } catch (error) {
        console.log("error", error)
        thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }
})

export const getWoFile = createAsyncThunk("appCommonReducers/getWoFile", async (fileId, thunkAPI) => {
    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
    const authAxios = DefaultConfig().authAxios
    const resultData = await authAxios.get(`FileUpload/GetFilePropertiesByFileId?fileId=${fileId}`)
    const resData = resultData.data
    if (resData) {
        if (resData.success) {
            const respData = resData.data
            if (respData) {
                const fileName = respData.fileName
                const contentType = respData.contentType
                const totalSize = Number(respData.contentLength)
                // const chunkSize = 1024 * 1024 * 1// 1MB chunk size
                const chunkCount = totalSize % chunkSize === 0 ? totalSize / chunkSize : Math.floor(totalSize / chunkSize) + 1
                const chunks = []
                let offset = 0
                let counter = 1
                // let count = 0
                // const concatenatedArray = new Uint8Array(totalSize)

                while (offset < totalSize) {
                    const end = Math.min(offset + chunkSize, totalSize) - 1
                    const respayload = await thunkAPI.dispatch(downloadChunk({ offset, end, totalSize, fileId }))
                    const chunk = respayload.payload

                    // const binaryString = Buffer.from(chunk, 'base64').toString('binary')
                    // const chunkUint8Array = new Uint8Array([...binaryString].map(char => char.charCodeAt(0)))
                    // concatenatedArray.set(chunkUint8Array, count * chunkSize)

                    chunks.push(chunk)
                    offset += chunkSize
                    if (counter === chunkCount) {
                        thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                    } else {
                        thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                    }
                    counter++
                    // count++
                }

                // // Combine base64 chunks into a single base64 string
                // const combinedBase64 = chunks.join('')
                // // Convert base64 string to binary data
                // const binaryData = atob(combinedBase64)
                // // Create array buffer from binary data
                // const arrayBuffer = new ArrayBuffer(binaryData.length)
                // const uint8Array = new Uint8Array(arrayBuffer)
                // for (let i = 0; i < binaryData.length; i++) {
                //   uint8Array[i] = binaryData.charCodeAt(i)
                // }

                // // Convert the Uint8Array to a Blob
                // const concatenatedBlob = new Blob([uint8Array], { type: contentType })

                const blobChunks = []
                // Fetch each chunk and push it to the array
                for (const chunk of chunks) {
                    const response = await fetch(`data:application/octet-stream;base64,${chunk}`)
                    const blob = await response.blob()
                    blobChunks.push(blob)
                }

                // Convert the Uint8Array to a Blob
                const concatenatedBlob = new Blob(blobChunks, { type: contentType })
                // Generate download URL
                const downloadUrl = URL.createObjectURL(concatenatedBlob)
                // Initiate a download by creating an anchor element and programmatically clicking it
                const link = document.createElement('a')
                link.href = downloadUrl
                let fileNameValue = fileName
                if (fileNameValue.includes("IHM_SOC")) {
                    fileNameValue = fileNameValue.replace("IHM_SOC", "IHM_IC")
                }
                link.download = fileNameValue
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(downloadUrl)

                return {
                    data: { fileName, contentType, fileContent: '' },
                    tokenExp: false
                }
            }
        } else {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    }
    // return resultData
})

export const getOpenFile = createAsyncThunk("appCommonReducers/getOpenFile", async (fileId, thunkAPI) => {
    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
    const authAxios = DefaultConfig().authAxios
    const resultData = await authAxios.get(`FileUpload/GetFilePropertiesByFileId?fileId=${fileId}`)
    const resData = resultData.data
    if (resData) {
        if (resData.success) {
            const respData = resData.data
            if (respData) {
                const fileName = respData.fileName
                const contentType = respData.contentType
                const totalSize = Number(respData.contentLength)
                // const chunkSize = 1024 * 1024 * 1// 1MB chunk size
                const chunkCount = totalSize % chunkSize === 0 ? totalSize / chunkSize : Math.floor(totalSize / chunkSize) + 1
                const chunks = []
                let offset = 0
                let counter = 1
                // let count = 0
                // const concatenatedArray = new Uint8Array(totalSize)

                while (offset < totalSize) {
                    const end = Math.min(offset + chunkSize, totalSize) - 1
                    const respayload = await thunkAPI.dispatch(downloadChunk({ offset, end, totalSize, fileId }))
                    const chunk = respayload.payload

                    // const binaryString = Buffer.from(chunk, 'base64').toString('binary')
                    // const chunkUint8Array = new Uint8Array([...binaryString].map(char => char.charCodeAt(0)))
                    // concatenatedArray.set(chunkUint8Array, count * chunkSize)

                    chunks.push(chunk)
                    offset += chunkSize
                    if (counter === chunkCount) {
                        thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                    } else {
                        thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                    }
                    counter++
                    // count++
                }

                if (chunks.length === 1 && (fileName.includes('.pdf') || fileName.includes('.PDF'))) {
                    // // Convert base64 string to a Blob
                    // const byteCharacters = atob(chunks)
                    // const byteNumbers = new Array(byteCharacters.length)
                    // for (let i = 0; i < byteCharacters.length; i++) {
                    //   byteNumbers[i] = byteCharacters.charCodeAt(i)
                    // }
                    // const byteArray = new Uint8Array(byteNumbers)
                    // const blob = new Blob([byteArray], { type: 'application/pdf' })

                    const blobChunks = []
                    // Fetch each chunk and push it to the array
                    for (const chunk of chunks) {
                        const response = await fetch(`data:application/pdf;base64,${chunk}`)
                        const blob = await response.blob()
                        blobChunks.push(blob)
                    }
                    const blob = new Blob(blobChunks, { type: 'application/pdf' })

                    // Create a Blob URL
                    const blobUrl = URL.createObjectURL(blob)
                    // Open a new tab with the Blob URL
                    window.open(blobUrl, '_blank')
                } else {
                    // // Combine base64 chunks into a single base64 string
                    // const combinedBase64 = chunks.join('')
                    // // Convert base64 string to binary data
                    // const binaryData = atob(combinedBase64)
                    // // Create array buffer from binary data
                    // const arrayBuffer = new ArrayBuffer(binaryData.length)
                    // const uint8Array = new Uint8Array(arrayBuffer)
                    // for (let i = 0; i < binaryData.length; i++) {
                    //   uint8Array[i] = binaryData.charCodeAt(i)
                    // }

                    // // Convert the Uint8Array to a Blob
                    // const concatenatedBlob = new Blob([uint8Array], { type: contentType })

                    const blobChunks = []
                    // Fetch each chunk and push it to the array
                    for (const chunk of chunks) {
                        const response = await fetch(`data:application/octet-stream;base64,${chunk}`)
                        const blob = await response.blob()
                        blobChunks.push(blob)
                    }
                    const concatenatedBlob = new Blob(blobChunks, { type: contentType })
                    // Generate download URL
                    const downloadUrl = URL.createObjectURL(concatenatedBlob)
                    // Initiate a download by creating an anchor element and programmatically clicking it
                    const link = document.createElement('a')
                    link.href = downloadUrl
                    let fileNameValue = fileName
                    if (fileNameValue.includes("IHM_SOC")) {
                        fileNameValue = fileNameValue.replace("IHM_SOC", "IHM_IC")
                    }
                    link.download = fileNameValue
                    link.style.display = 'none'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(downloadUrl)
                }

                return {
                    data: { fileName, contentType, fileContent: '' },
                    tokenExp: false
                }
            }
        } else {
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
    }
    // return resultData
})

export const saveMultipleFileUploads = createAsyncThunk("appCommonReducers/saveMultipleFileUploads", async (values) => {
    if (values.fileDto.length > 0) {
        const formData = new FormData()
        formData.append("file", values.fileDto[0].file)
        const authAxios = DefaultConfig().authAxios
        const resultData = await authAxios
            .patch(`MultipleFileUpload?wo_id=${values.woId}`, formData).then((response) => {
                const respData = response.data
                if (respData) {
                    const resData = respData.data
                    if (resData) {
                        return {
                            data: resData,
                            spinner: true,
                            tokenExp: false
                        }
                    }
                }
            }).catch((error) => {
                const errorresponse = error.response
                if (errorresponse) {
                    const status = errorresponse.status
                    if (status === 403) {
                        toast(t => (<ToastMessage t={t} message={"The system was unable to complete the process due to security restrictions. Please try again later or contact support for further assistance"} status={"danger"} />))
                        return {
                            data: [],
                            spinner: false,
                            tokenExp: true
                        }
                    } else {
                        const error = errorresponse.data.error
                        toast(t => (<ToastMessage t={t} message={error} status={"danger"} />))
                        return {
                            data: [],
                            spinner: false,
                            tokenExp: false
                        }
                    }
                }
            })
        return resultData
    }
})

export const removeWoFile = createAsyncThunk("appCommonReducers/removeWoFile", async (values) => {
    const method = 'delete'
    const endpoint = `${ApiUrls.RemoveWorkorderDocument}?woId=${values.woId}&fileId=${values.fileId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})
// End File Upload, download and remove files

export const callApi = createAsyncThunk("appCommonReducers/callApi", async (data) => {
    return data
})

// Seafarer API's
export const getVesselByofficialNumber = createAsyncThunk("appCommonReducers/getVesselByofficialNumber", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetVesselByOfficialNumber}?officialNumber=${wdata.officialNumber}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getValidateSCDUserDetails = createAsyncThunk("appCommonReducers/getValidateSCDUserDetails", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateSCDUserDetails}`
    const data = wdata.arrayValue
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetComValidateSCDUserDetails = createAsyncThunk("appCommonReducers/GetComValidateSCDUserDetails", async (wdata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetComValidateSCDUserDetails}`
    const data = wdata.arrayValue
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const ValidateAgentName = createAsyncThunk("appCommonReducers/ValidateAgentName", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateAgentName}?Name=${wdata.name}&IsExistingAgent=${wdata.isExistingAgent}`
    const resultData = await apiCall(method, endpoint)
    if (resultData) {
        return resultData
    }
})

export const ValidateRaAgentName = createAsyncThunk("appCommonReducers/ValidateRaAgentName", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateRaAgentName}?Name=${wdata.name}`
    const resultData = await apiCall(method, endpoint)
    if (resultData) {
        return resultData
    }
})

export const GetAffliationParentData = createAsyncThunk("appCommonReducers/GetAffliationParentData", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAffliationParentData}?agentId=${wdata.AgentNumber}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return resultData
    }
})

export const getValidateAgentNumber = createAsyncThunk("appCommonReducers/getValidateAgentNumber", async (wdata) => {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateAgentNumber}?AgentNumber=${wdata.AgentNumber}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const setShowHideMenuData = createAsyncThunk("appCommonReducers/setShowHideMenuData", async (name) => {
    return name
})

export const getStepNameStatus = createAsyncThunk("appCommonReducers/getStepNameStatus", async (name) => {
    return name
})

export const getClearStatus = createAsyncThunk("appCommonReducers/getClearStatus", async () => {
    return ''
})

export const insreload = createAsyncThunk("appCommonReducers/insreload", async () => {
    return ''
})

export const getClearMultiStatus = createAsyncThunk("appCommonReducers/getClearMultiStatus", async () => {
    return ''
})

export const getClearPaymentStatus = createAsyncThunk("appCommonReducers/getClearPaymentStatus", async () => {
    return ''
})

export const createWorkorder = createAsyncThunk("appCommonReducers/createWorkorder", async (boolean) => {
    return { boolean }
})

export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async () => {
    return ''
})

export const getClearStore = createAsyncThunk("appCommonReducers/getClearStore", async () => {
    return ''
})

export const getClearStoreData = createAsyncThunk("appCommonReducers/getClearStoreData", async () => {
    return ''
})

export const getClearFileData = createAsyncThunk("appCommonReducers/getClearFileData", async () => {
    return ''
})

export const removeneedinfodata = createAsyncThunk("appCommonReducers/removeneedinfodata", async () => {
    return ''
})

export const getFileExceed = createAsyncThunk("appCommonReducers/getFileExceed", async () => {
    return ''
})

export const getWorkOrdersDataByAgentId = createAsyncThunk("appCommonReducers/GetWorkOrdersDataByAgentId", async (adata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetWorkOrdersDataByAgentId}?agentId=${adata.agentId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getSCDUsersByAgentId = createAsyncThunk("appCommonReducers/GetSCDUsersByAgentId", async (adata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetSCDUsersByAgentId}?agentId=${adata.agentId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getAffiliatesByAgentId = createAsyncThunk("appCommonReducers/GetAffiliatesByAgentId", async (adata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetAffiliatesByAgentId}?agentId=${adata.agentId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)

    if (resultData) {

        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const getSEAPortalRevenues = createAsyncThunk("appCommonReducers/GetSEAPortalRevenues", async (adata) => {
    const method = 'post'
    const endpoint = `${ApiUrls.GetSEAPortalRevenues}`
    const data = adata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const recCount = resultData.count
        const gridSize = resultData.pageSize
        const workordesCount = resultData.workordesCount
        const invoiceCount = resultData.invoiceCount
        const agentsCount = resultData.agentsCount
        const totalRevenue = resultData.totalRevenue
        const invoiceData = resultData.seaPortalRevenue_DTO ? resultData.seaPortalRevenue_DTO : []
        const invoiceChartData = resultData.seaPortalRevenueChart_DTO ? resultData.seaPortalRevenueChart_DTO : []

        return {
            data: invoiceData,
            recCount,
            gridSize,
            workordesCount,
            invoiceCount,
            agentsCount,
            totalRevenue,
            invoiceChartData,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const getActiveAgentsBreakdown = createAsyncThunk("appCommonReducers/GetActiveAgentsBreakdown", async (adata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetActiveAgentsBreakdown}?startDate=${adata.startDate}&endDate=${adata.endDate}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetWorkorderProductCodes = createAsyncThunk("appCommonReducers/GetWorkorderProductCodes", async (adata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetWorkorderProductCodes}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetAuditReport = createAsyncThunk("appCommonReducers/GetAuditReport", async (wdata) => {
    const woidDate = wdata.object
    const method = 'get'
    const endpoint = `${woidDate.ccode}/${woidDate.tcode}/${ApiUrls.GetAuditReport}?woId=${woidDate.woId}`
    const data = wdata.woidDate
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const ProcessAuditReportStage = createAsyncThunk("appCommonReducers/ProcessAuditReportStage", async (wdata) => {
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ProcessAuditReportStage}`
    const data = getData(wdata.obj)
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData.workorderData
        return {
            data: workorderData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetMPDetailsFilter = createAsyncThunk("appCommonReducers/GetMPDetailsFilter", async (obj) => {
    const method = 'post'
    const endpoint = ApiUrls.GetMPDetailsFilter
    const data = obj
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workordersDto = resultData.mpDetailsList ? resultData.mpDetailsList : []
        const recCount = resultData.totalCount
        const gridSize = resultData.pageSize
        return {
            data: workordersDto,
            recCount,
            gridSize,
            spinner: true,
            tokenExp: false
        }
    } else {
        return {
            data: [],
            spinner: true,
            tokenExp: false
        }
    }
})

export const SearchMPList = createAsyncThunk("appCommonReducers/SearchMPList", async (wdata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.SearchMPList}?searchValue=${wdata.value}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    return resultData
})

export const GetMPWorkOrdersDataByAgentId = createAsyncThunk("appCommonReducers/GetMPWorkOrdersDataByAgentId", async (adata) => {
    const method = 'get'
    const endpoint = `${ApiUrls.GetMPWorkOrdersDataByAgentId}?agentId=${adata.agentId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData.mpDetailsData,
            data1: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetDownloadData = createAsyncThunk("appCommonReducers/GetDownloadData", async (code) => {
    const woId = code?.woData?.id
    const method = 'get'
    const endpoint = `${code.ccode}/${code.tcode}/${ApiUrls.GetDownloadData}?woId=${woId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetDownloadCertData = createAsyncThunk("appCommonReducers/GetDownloadCertData", async (code) => {
    const woId = code?.woId
    const fileId = code?.fileId
    const method = 'get'
    const endpoint = `${code.ccode}/${code.tcode}/${ApiUrls.GetDownloadCertData}?woId=${woId}&fileId=${fileId}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const DeactivateRole = createAsyncThunk("appCommonReducers/DeactivateRole", async (wdata) => {
    const method = 'post'
    const endpoint = `FA/AFF/${ApiUrls.DeactivateRole}`
    const data = wdata
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        return {
            data: resultData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const GetPaymentStatus = createAsyncThunk("appCommonReducers/GetPaymentStatus", async (wdata) => {
    const method = 'get'
    const endpoint = `Common/${ApiUrls.GetPaymentStatus}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
        const workorderData = resultData
        return {
            data: workorderData,
            spinner: true,
            tokenExp: false
        }
    }
})

export const commonreducerSlice = createSlice({
    name: 'appCommonReducers',
    initialState: {
        menuBoolean: false,
        empMenuData: [
            {
                id: "home",
                title: "Home",
                icon: '',
                img: themeConfig.navicons.home,
                img1: themeConfig.navicons.home1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/home",
                show: true
            },
            {
                id: "workOrders",
                title: "Work Orders",
                icon: '',
                img: themeConfig.navicons.Search,
                img1: themeConfig.navicons.Search1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/workorders",
                show: true
            },
            {
                id: "filingAgent",
                title: "Filing Agent",
                img: themeConfig.navicons.kpi,
                img1: themeConfig.navicons.kpi1,
                icon: '',
                show: true,
                color1: '#fff',
                navLink: "/filing-agent",
                children: [
                    {
                        id: "kpi",
                        title: "Dashboard (KPI)",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/filing-agent/kpi"
                    },
                    {
                        id: "agent",
                        title: "Agent Details",
                        img: themeConfig.navicons.agent,
                        img1: themeConfig.navicons.agent1,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/filing-agent/agent"
                    },
                    {
                        id: "fguserManagement",
                        title: "User Management",
                        img: themeConfig.navicons.userMangement,
                        img1: themeConfig.navicons.userMangement1,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/filing-agent/user-management"
                    }
                ]
            },
            {
                id: "trainingCenter",
                title: "Training Center",
                img: themeConfig.navicons.tcImage,
                img1: themeConfig.navicons.tcImage1,
                icon: '',
                show: true,
                color1: '#fff',
                navLink: "/training-center",
                children: [
                    {
                        id: "tcdashboard",
                        title: "Dashboard",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/training-center/dashboard"
                    },
                    {
                        id: "tcuserManagement",
                        title: "User Management",
                        img: themeConfig.navicons.userMangement,
                        img1: themeConfig.navicons.userMangement1,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/training-center/user-management"
                    }
                ]
            },
            {
                id: "seafearerStudent",
                title: "Seafarer Student",
                img: themeConfig.navicons.ssImage,
                img1: themeConfig.navicons.ssImage1,
                icon: '',
                show: true,
                color1: '#fff',
                navLink: "/seafearer-student",
                children: [
                    {
                        id: "ssdashboard",
                        title: "Dashboard",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/seafearer-student/dashboard"
                    },
                    {
                        id: "ssuserManagement",
                        title: "User Management",
                        img: themeConfig.navicons.userMangement,
                        img1: themeConfig.navicons.userMangement1,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/seafearer-student/user-management"
                    }
                ]
            },
            {
                id: "medicalClinics",
                title: "Medical Clinics",
                img: themeConfig.navicons.mcImage,
                img1: themeConfig.navicons.mcImage1,
                icon: '',
                show: true,
                color1: '#fff',
                navLink: "/medical-clinics",
                children: [
                    {
                        id: "mcdashboard",
                        title: "Dashboard",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/medical-clinics/dashboard"
                    },
                    {
                        id: "mcSearch",
                        title: "Inquiry",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/medical-clinics/inquiry"
                    },
                    {
                        id: "mcDoctorDetails",
                        title: "Doctor Details",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/medical-clinics/doctor-details"
                    },
                    {
                        id: "mcuserManagement",
                        title: "User Management",
                        img: themeConfig.navicons.userMangement,
                        img1: themeConfig.navicons.userMangement1,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/medical-clinics/user-management"
                    }
                ]
            },
            {
                id: "admin",
                title: "Admin",
                img: themeConfig.navicons.agent,
                img1: themeConfig.navicons.agent1,
                icon: '',
                show: true,
                color1: '#fff',
                navLink: "/admin",
                children: [
                    {
                        id: "finance",
                        title: "Finance",
                        img: themeConfig.navicons.dashboard,
                        img1: themeConfig.navicons.dashboard1,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/admin/finance"
                    }
                ]
            },
            {
                id: "appSettings",
                title: "Role Management",
                icon: '',
                img: themeConfig.navicons.appSettings,
                img1: themeConfig.navicons.appSettings1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/role-management",
                show: false
            },
            {
                id: "account",
                title: "Account",
                icon: '',
                img: themeConfig.navicons.Profile,
                img1: themeConfig.navicons.Profile1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/my-profile",
                show: true
            }
        ],
        cusMenuData: [
            {
                id: "home",
                title: "Home",
                icon: '',
                img: themeConfig.navicons.home,
                img1: themeConfig.navicons.home1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/home",
                show: true
            },
            {
                id: "dashboard",
                title: "Dashboard",
                icon: '',
                img: themeConfig.navicons.dashboard,
                img1: themeConfig.navicons.dashboard1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/dashboard",
                show: false
            },
            {
                id: "filingAgent",
                title: "Filing Agent",
                img: themeConfig.navicons.mcImage,
                img1: themeConfig.navicons.mcImage1,
                icon: '',
                show: false,
                color1: '#fff',
                navLink: "/filing-agent",
                children: [
                    {
                        id: "agent",
                        title: "Agent Details",
                        img: themeConfig.navicons.agent,
                        img1: themeConfig.navicons.agent1,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/filing-agent/agent"
                    }
                ]
            },
            {
                id: "trainingCenter",
                title: "Training Center",
                img: themeConfig.navicons.kpi,
                img1: themeConfig.navicons.kpi1,
                icon: '',
                show: false,
                color1: '#fff',
                navLink: "/training-center",
                children: [
                    {
                        id: "tcdashboard",
                        title: "Dashboard",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/training-center/dashboard"
                    }
                ]
            },
            {
                id: "seafearerStudent",
                title: "Seafarer Student",
                img: themeConfig.navicons.ssImage,
                img1: themeConfig.navicons.ssImage1,
                icon: '',
                show: false,
                color1: '#fff',
                navLink: "/seafearer-student",
                children: [
                    {
                        id: "ssdashboard",
                        title: "Dashboard",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/seafearer-student/dashboard"
                    }
                ]
            },
            {
                id: "medicalClinics",
                title: "Medical Clinics",
                img: themeConfig.navicons.mcImage,
                img1: themeConfig.navicons.mcImage1,
                icon: '',
                show: false,
                color1: '#fff',
                navLink: "/medical-clinics",
                children: [
                    {
                        id: "mcdashboard",
                        title: "Dashboard",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        navLink: "/medical-clinics/dashboard"
                    }
                ]
            },
            {
                id: "workOrders",
                title: "Work Orders",
                icon: '',
                img: themeConfig.navicons.Search,
                img1: themeConfig.navicons.Search1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/workorders",
                show: true
            },
            {
                id: "account",
                title: "Account",
                icon: '',
                img: themeConfig.navicons.Profile,
                img1: themeConfig.navicons.Profile1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/my-profile",
                show: true
            },
            {
                id: "userManagement",
                title: "User Management",
                icon: '',
                img: themeConfig.navicons.userMangement,
                img1: themeConfig.navicons.userMangement1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/user-management",
                show: true
            }
        ],
        woCates: [],
        dirtyBool: false,
        timeCheck: false,
        spinner1: false,
        enableAction: false,

        woStages: [],
        spinner2: false,

        invoiceTotAmount: 0,

        woData: [],
        spinner3: false,
        recCount: 0,
        gridSize: 0,
        srGridSize: 0,
        srRecCount: 0,

        srAgentCount: 0,
        srInVoiceCount: 0,
        srTotalRevenue: 0,
        srWorkOrderCount: 0,
        invoiceChartData: [],

        cloader: false,
        countryStates: [],
        seaSystemDates: [],
        servicesList: [],
        practitionerList: [],

        dloader: false,
        documentTypes: [],

        woIData: null,
        spinner4: false,

        needMoreTracking: false,

        woIdComments: [],
        spinnerComment: false,
        needstatus: '',
        needcomment: '',

        wloader: false,
        woIdData: null,
        invoiceFileId: null,
        autherizationFileId: null,
        pdfData: null,

        woIdDocs: [],
        wdloader: false,

        fileData: {},
        uploadErrMsg: '',
        woType: '',
        stype: '',
        woTypeId: null,
        floader: true,

        filePreData: {},

        mfileData: {},
        mloader: true,

        tokenExp: false,

        invoiceData: {},
        ispinner: false,

        woBool: false,

        allCompanies: [],
        allCustomerCompanies: [],
        allCustomQuestions: [],
        allPrimaryCompanies: [],
        allPrimaryBillingAddress: [],
        acSpinner: false,
        cusSpinner: false,
        acPrimarySpinner: false,
        checkwoData: null,

        invoicefileData: null,

        RCWVendorSpinner: false,
        RCWVesOwnerSpinner: false,


        imoloader: false,
        imoData: [],

        imovloader: false,

        imocloader: false,
        imoCompanyData: [],

        total: 0,
        counter: 0,
        progress: false,
        fileCount: 0,
        totalfilecount: [],
        progressFolder: false,
        totalfilecountFolder: [],

        fileStatus: '',
        fileExceed: false,

        bwloader: false,
        bwData: null,
        dirtyValue: false,

        agloader: false,
        agData: null,

        agloaderBwo: false,
        agDataBwo: null,

        itloader: false,
        itData: null,

        usersData: null,
        uspiner: false,
        userRoleData: null,
        urspiner: false,

        creload: false,
        courseData: [],
        dummpyData: {},
        crreload: false,
        courseRefData: [],
        ccreload: false,
        certiData: [],

        insreload: false,
        allInsData: [],
        courseDeatilsData: [],

        validateCData: null,
        Comdet: null,
        pvSpinner: false,
        pvData: null,
        scdDetails: false,
        pspinner: false,
        allproductCodes: [],
        updateApiCall: {},
        unEditableFields: [],
        uploadedCount: 0,
        agentBasedCompleteData: null,
        agentBasedSCDData: null,
        agentBasedAffiliatesData: null,
        seaPortalRevenues: null,
        activeAgentsDetails: null,
        allAgentMapData: [],
        allUserMapData: [],
        isProcessing: false,
        traingDirectorEmail: '',
        isProcessing: false,
        parseData: null,
        activeRequests: 0,
        crewTotList: [],
        agInfSpiner: false,
        agentInfoData: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getWorkOrderTypesAndCategories.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner1 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    const resData = action.payload.data
                    const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn()).isEmployee
                    const userData = JSON.parse(localStorage.getItem('userData'))
                    let woIdTypeData = []
                    let allAccess = false
                    if (userData) {
                        const userRoles = userData.userRoles
                        if (!isEmployee) {
                            state.enableAction = true
                        }
                        if (userRoles?.length > 0) {
                            const findRole = userRoles.find(find => find.rId === 1)
                            if (findRole && isEmployee) {
                                state.enableAction = true
                            }
                            for (let i = 0; i < userRoles.length; i++) {
                                const role = userRoles[i]
                                if (role.rId === 1 || role.rId === 2 || role.rId === 3) {
                                    woIdTypeData = []
                                    allAccess = true
                                    break
                                } else {
                                    const wtId = role.wtId
                                    if (wtId) {
                                        if (!woIdTypeData.includes(wtId)) {
                                            woIdTypeData.push(wtId)
                                        }
                                    }
                                }
                            }
                        }
                    }
                    const woCatgs = []
                    if ((isEmployee) ? (woIdTypeData.length > 0 || allAccess) : true) {
                        resData.forEach((element) => {
                            const woTypesData = []
                            const filingAgentTypes = ['APP', 'CAS', 'CSA', 'FCA', 'FAA', 'AFF', 'FVA', 'FUA', 'FDA', 'RA', 'RCA', 'AA']
                            // if (getUserRole()) {
                            //     filingAgentTypes.push('AA')
                            // }
                            if (element.workorderTypes) {
                                element.workorderTypes.forEach((ele) => {
                                    if ((element.categoryCode === 'FA' && [...filingAgentTypes].includes(ele.typeCode)) ||
                                        (element.categoryCode === 'CG' && ['MCG'].includes(ele.typeCode)) ||
                                        (element.categoryCode === 'MT' && ['TCA', 'CA', 'MCA', 'LCC', "MDA", "TRE", "MRA", "TCR", "CAR", 'IA'].includes(ele.typeCode)) ||
                                        (element.categoryCode === 'MP' && ['MPA', 'RC', 'LCC', "PEC", "RPA"].includes(ele.typeCode)) ||
                                        (element.categoryCode === 'MCR' && ['DA', 'MCC', 'CAS'].includes(ele.typeCode)) ||
                                        (element.categoryCode === 'RTC' && ['TCA', 'LCC'].includes(ele.typeCode)) ||
                                        (element.categoryCode === 'MCA' && ['DA', 'RC', 'APP', "MB", "APR"].includes(ele.typeCode))) {
                                        if (isEmployee ? (allAccess ? true : (woIdTypeData.includes(ele.typeId))) : true) {
                                            if (element.categoryCode === 'FA' && ['CAS', 'RCA'].includes(ele.typeCode)) {
                                                woTypesData.push({ value: ele.typeId, label: ele.type, code: ele.typeCode, description: ele.description, disabled: true, isPublic: ele.isPublic })
                                            } else {
                                                woTypesData.push({ value: ele.typeId, label: ele.type, code: ele.typeCode, description: ele.description, disabled: false, isPublic: ele.isPublic })
                                            }
                                        }
                                    }
                                })
                            }
                            if (woTypesData.length > 0) {
                                woCatgs.push({ value: element.categoryId, label: element.category, code: element.categoryCode, description: element.description, woTypes: woTypesData })
                            }
                        })
                    }

                    if (woCatgs.length > 0) {
                        state.woCates = woCatgs
                    } else {
                        state.woCates = []
                    }
                }
            })
            .addCase(getWorkorderStages.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner2 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woStages = action.payload.data
                }
            })
            .addCase(getCompanyDetails.fulfilled, (state, action) => {
                if (action.payload) {
                    state.acSpinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.allCompanies = action.payload.data
                }
            })
            .addCase(GetCustomerCompanyDetails.fulfilled, (state, action) => {
                if (action.payload) {
                    state.cusSpinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.allCustomerCompanies = action.payload.data
                    // if (action.payload.data) {
                    //     const data = action.payload.data
                    //     let cusMenuData = state.cusMenuData

                    //     // Condition 1: All numbers
                    //     const hasAllNumbers = data.some(item => /^\d+$/.test(item.value))
                    //     // Condition 2: Starts with MTTCA
                    //     const hasMTTCA = data.some(item => item.value?.startsWith("MTTCA"))
                    //     // Condition 3: Starts with SFR
                    //     const hasSFR = data.some(item => item.value?.startsWith("SFR"))
                    //     // Condition 4: Starts with MC
                    //     const hasMC = data.some(item => item.value?.startsWith("MC"))

                    //     cusMenuData = cusMenuData.map(menuItem => {
                    //         if (menuItem.id === "filingAgent" && hasAllNumbers) {
                    //             return { ...menuItem, show: true }
                    //         }
                    //         if (menuItem.id === "trainingCenter" && hasMTTCA) {
                    //             return { ...menuItem, show: true }
                    //         }
                    //         if (menuItem.id === "seafearerStudent" && hasSFR) {
                    //             return { ...menuItem, show: true }
                    //         }
                    //         if (menuItem.id === "medicalClinics" && hasMC) {
                    //             return { ...menuItem, show: true }
                    //         }
                    //         return menuItem
                    //     })
                    //     state.cusMenuData = cusMenuData
                    // }
                }
            })
            .addCase(CreateQuestionResponse.fulfilled, (state, action) => {
                if (action.payload) {
                    state.acSpinner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.allCustomQuestions = action.payload.data
                }
            })
            .addCase(getCountryStates.fulfilled, (state, action) => {
                if (action.payload) {
                    state.cloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.countryStates = action.payload.data
                }
            })
            .addCase(CheckCodes.fulfilled, (state, action) => {
                if (action.payload) {
                    state.cloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.seaSystemDates = action.payload.data
                }
            })
            .addCase(GetServiceProviderAgents.fulfilled, (state, action) => {
                if (action.payload) {
                    state.cloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.servicesList = action.payload.data.map(item => ({
                        ...item,
                        label: `${item.name} - ${item.agentId}`,
                        value: item.agentId
                    }))
                }
            })
            .addCase(GetAffiliateAgents.fulfilled, (state, action) => {
                if (action.payload) {
                    state.cloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.practitionerList = action.payload.data.map(item => ({
                        ...item,
                        label: `${item?.practionerId}`,
                        value: item?.practionerId
                    }))
                }
            })
            // .addCase(ValidatePractionerId.fulfilled, (state, action) => {
            //     if (action.payload) {
            //         state.cloader = action.payload.spinner
            //         state.tokenExp = action.payload.tokenExp
            //         state.servicesList = action.payload.data.map(item => ({
            //             ...item,
            //             label: `${item.name} - ${item.agentId}`,
            //             value: item.agentId
            //         }))
            //     }
            // })
            .addCase(getWorkorders.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner3 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woData = action.payload.data
                    state.recCount = action.payload.recCount
                    state.gridSize = action.payload.gridSize
                }
            })
            .addCase(getWorkordersByFilters.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner3 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woData = action.payload.data
                    state.recCount = action.payload.recCount
                    state.gridSize = action.payload.gridSize
                }
            })
            .addCase(GetTotalInvoiceRevenue.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner3 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woData = action.payload.data
                    state.recCount = action.payload.recCount
                    state.gridSize = action.payload.gridSize
                    state.invoiceTotAmount = action.payload.amount
                }
            })
            .addCase(displayMenu.fulfilled, (state, action) => {
                state.displayMenuBool = action.payload
            })
            .addCase(updateDirtyBool.fulfilled, (state, action) => {
                state.updateDirtyBool = action.payload
            })
            .addCase(timeCheck.fulfilled, (state, action) => {
                state.timeCheck = action.payload
            })
            .addCase(ValidateWorkorderCreation.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.checkwoData = action.payload.data
                }
            })
            .addCase(getBaseWorkorderData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.bwloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.bwData = action.payload.data
                }
            }).addCase(getAgentInformationnData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.agInfSpiner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.agentInfoData = action.payload.data
                }
            }).addCase(GetUsers.fulfilled, (state, action) => {
                if (action.payload) {
                    state.uspiner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.usersData = action.payload.data
                }
            }).addCase(GetUserRoles.fulfilled, (state, action) => {
                if (action.payload) {
                    state.urspiner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.userRoleData = action.payload.data
                }
            })
            .addCase(SaveUserRoles.fulfilled, (state, action) => {
                if (action.payload) {
                    state.urspiner = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                }
            })
            .addCase(GetApprovedCoursesAndReferences.fulfilled, (state, action) => {
                if (action.payload) {
                    state.creload = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.courseData = action.payload.data
                }
            })
            .addCase(GetCourseDetails.fulfilled, (state, action) => {
                if (action.payload) {
                    state.creload = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.courseData = action.payload.data
                    state.courseDeatilsData = action.payload.data
                    state.bindingCourseDetails = action.payload.data1
                }
            })
            .addCase(GetApprovedCourses.fulfilled, (state, action) => {
                if (action.payload) {
                    state.creload = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.courseData = action.payload.data
                }
            })
            .addCase(GetApprovedCourseReferences.fulfilled, (state, action) => {
                if (action.payload) {
                    state.crreload = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.courseRefData = action.payload.data
                }
            })
            .addCase(GetApprovedCapacityofCertificate.fulfilled, (state, action) => {
                if (action.payload) {
                    state.ccreload = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.certiData = action.payload.data
                }
            })
            .addCase(getAllInstructorDetails.fulfilled, (state, action) => {
                if (action.payload) {
                    // state.insreload = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.allInsData = action.payload.data
                }
            })
            .addCase(applicationDataBinding.fulfilled, (state, action) => {
                if (action.payload) {
                    // state.insreload = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.dummpyData = action.payload
                }
            })
            .addCase(insreload.fulfilled, (state, action) => {
                state.insreload = true
            })
            .addCase(GetInvoiceLoader.fulfilled, (state) => {
                state.itloader = false
            })
            .addCase(GetUserLoader.fulfilled, (state) => {
                state.cusSpinner = true
            })
            .addCase(getDocumentTemplateData.fulfilled, (state, action) => {
                if (action.payload) {
                    if (action.payload.reqData) {
                        if (action.payload.reqData.docType === 'Agr') {
                            state.agloader = action.payload.spinner
                            state.agData = action.payload.data
                        } else if (action.payload.reqData.docType === 'AgrBwo') {
                            state.agloaderBwo = action.payload.spinner
                            state.agDataBwo = action.payload.data
                        } else {
                            state.itloader = action.payload.spinner
                            state.itData = action.payload.data
                        }
                    }
                    state.tokenExp = action.payload.tokenExp
                }
            })
            .addCase(CreateWorkorder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            })
            .addCase(getWorkordersData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    state.dirtyBool = false
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            }).addCase(updateWoData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    state.dirtyBool = true
                    state.updateDirtyBool = false
                    state.timeCheck = false
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                }
            }).addCase(saveCSVRCWDocument.fulfilled, (state, action) => {
                if (action.payload) {
                    state.floader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.fileData = action.payload.data
                    state.woType = action.payload.woType
                    state.woTypeId = action.payload.woTypeId
                    state.stype = action.payload.stype
                    state.uploadErrMsg = action.payload.errorMsg
                } else {
                    state.floader = true
                }
            }).addCase(getInvoiceFileData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.invoicefileData = action.payload.data
                }
            }).addCase(AddorRemoveProformaInvoice.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                }
            }).addCase(UpdateProductCodes.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                }
            }).addCase(UpdateProformaInvoice.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                }
            }).addCase(GnerateInvoice.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            }).addCase(UpdateWorkorder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    state.dirtyBool = false
                    state.updateDirtyBool = false
                    state.timeCheck = false
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            }).addCase(AcceptProofOfAffliationDoc.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    if (action.payload.data || action.payload.data1) {
                        state.woIdData = action.payload.data
                        state.woIData = action.payload.data1
                    }
                    state.spinner4 = action.payload.spinner
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            }).addCase(SyncAffiliateDetailsWithSCD.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    if (action.payload.data || action.payload.data1) {
                        state.woIdData = action.payload.data
                        state.woIData = action.payload.data1
                    }
                    state.spinner4 = action.payload.spinner
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            })
            .addCase(UpdateIsNeedMoreInfo.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            }).addCase(RejectProofOfAffliationDoc.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            }).addCase(RejectWorkOrder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            }).addCase(UpdateNeedMoreInfoStatus.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            })
            .addCase(CancelWorkorder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }
            })
            .addCase(getWorkordersById.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner4 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIData = action.payload.data
                }
            })
            .addCase(getWorkordersByIdComments.fulfilled, (state, action) => {
                state.spinnerComment = action.payload.spinner
                state.tokenExp = action.payload.tokenExp
                state.woIdComments = action.payload.data
            })
            .addCase(createWorkOrderComment.fulfilled, (state, action) => {
                const woIdComments = state.woIdComments
                woIdComments.push(action.payload?.data)
                state.spinnerComment = action.payload?.spinner
                state.tokenExp = action.payload?.tokenExp
                state.woIdComments = woIdComments
                state.needstatus = action.payload?.needstatus
                state.needcomment = action.payload?.needcomment
            })
            .addCase(saveFileUploads.fulfilled, (state, action) => {
                if (action.payload) {
                    if (!action.payload.type) {
                        state.floader = action.payload.spinner
                        state.tokenExp = action.payload.tokenExp
                        state.fileData = action.payload.data
                        state.woType = action.payload.woType
                        state.woTypeId = action.payload.woTypeId
                        state.stype = action.payload.stype
                        state.parseData = action.payload.parseData
                    } else {
                        state.mloader = action.payload.spinner
                        state.tokenExp = action.payload.tokenExp
                        state.mfileData = action.payload.data
                    }
                } else {
                    if (action.payload) {
                        if (!action.payload.type) {
                            state.floader = true
                        } else {
                            state.mloader = true
                        }
                    } else {
                        state.fileExceed = true
                    }
                }
            })
            .addCase(getUpdateFileData.fulfilled, (state, action) => {
                if (action.payload) {
                    state.total = action.payload.total
                    state.counter = action.payload.counter
                    state.progress = action.payload.progress
                    state.fileCount = action.payload.fileCount
                    state.totalfilecount = action.payload.totalfilecount
                    state.fileStatus = action.payload.fileStatus
                }
            })
            .addCase(getUpdateFileDataFolder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.total = action.payload.total
                    state.counter = action.payload.counter
                    state.progressFolder = action.payload.progress
                    state.fileCount = action.payload.fileCount
                    state.totalfilecountFolder = action.payload.totalfilecount
                    state.fileStatus = action.payload.fileStatus
                    state.uploadedCount = action.payload.uploadedCount
                }
            })
            .addCase(removeWoFile.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                }
            })
            .addCase(getWoFile.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.filePreData = action.payload.data
                }
            })
            .addCase(getOpenFile.fulfilled, (state, action) => {
                if (action.payload) {
                    state.tokenExp = action.payload.tokenExp
                    state.filePreData = action.payload.data
                }
            })
            .addCase(saveMultipleFileUploads.fulfilled, (state, action) => {
                if (action.payload) {
                    state.mloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.mfileData = action.payload.data
                } else {
                    state.mloader = true
                }
            })
            .addCase(setShowHideMenuData.fulfilled, (state, action) => {
                const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn()).isEmployee
                const name = action.payload
                const empMenuData = state.empMenuData
                const cusMenuData = state.cusMenuData
                if (isEmployee) {
                    if (name) {
                        const findIndex = empMenuData.findIndex(find => find.title === "Library")
                        if (findIndex >= 0) {
                            empMenuData[findIndex].show = true
                        }
                    } else {
                        const findIndex = empMenuData.findIndex(find => find.title === "Library")
                        if (findIndex >= 0) {
                            empMenuData[findIndex].show = false
                        }
                    }
                    state.empMenuData = empMenuData
                    state.menuBoolean = !state.menuBoolean
                } else {
                    if (name) {
                        const findIndex = cusMenuData.findIndex(find => find.title === "Library")
                        if (findIndex >= 0) {
                            cusMenuData[findIndex].show = true
                        }
                    } else {
                        const findIndex = cusMenuData.findIndex(find => find.title === "Library")
                        if (findIndex >= 0) {
                            cusMenuData[findIndex].show = false
                        }
                    }
                    state.cusMenuData = cusMenuData
                    state.menuBoolean = !state.menuBoolean
                }
            })
            .addCase(getStepNameStatus.fulfilled, (state) => {
                state.wdloader = false
                state.dloader = false
                // state.wloader = false
                state.cloader = false
                state.ispinner = false
            })
            .addCase(createWorkorder.fulfilled, (state, action) => {
                state.woBool = action.payload.boolean
            })
            .addCase(getClearMultiStatus.fulfilled, (state) => {
                state.mfileData = {}
            })
            .addCase(getClearStatus.fulfilled, (state) => {
                state.wdloader = false
                state.dloader = false
                state.dirtyValue = false
                state.wloader = false
                state.cloader = false
                state.ispinner = false
                state.woIData = null
                state.spinner3 = false
                state.bwloader = false
                state.bwData = null
                state.agloader = false
                state.agData = null
                state.agloaderBwo = false
                state.agDataBwo = null
                state.itloader = false
                state.itData = null
                state.imoData = []
                state.imoloader = false
                state.invoicefileData = null
                state.bindingCourseDetails = []
                state.courseDeatilsData = []
                state.insreload = false
                state.servicesList = []
                state.practitionerList = []
                state.dummpyData = {}
                state.timeCheck = false
            })
            .addCase(getClearPaymentStatus.fulfilled, (state) => {
                state.billedVesselSpin = false
                state.wloader = false
                state.ispinner = false
                state.spinner4 = false
                state.woIData = null
                state.woIdData = null
                state.dummpyData = {}
                state.timeCheck = false
            })
            .addCase(getWoLoading.fulfilled, (state) => {
                state.spinner3 = false
            })
            .addCase(getClearStore.fulfilled, (state) => {
                state.woIdData = null
                state.woIData = null
                state.checkwoData = null
                state.dummpyData = {}
                state.timeCheck = false
            })
            .addCase(getClearStoreData.fulfilled, (state) => {
                state.checkwoData = null
                state.timeCheck = false
            })
            .addCase(getClearFileData.fulfilled, (state) => {
                state.fileData = {}
                state.floader = true
                state.timeCheck = false
            })
            .addCase(removeneedinfodata.fulfilled, (state) => {
                state.needcomment = ''
                state.needstatus = ''
            })
            .addCase(getFileExceed.fulfilled, (state) => {
                state.fileExceed = false
            })
            .addCase(callApi.fulfilled, (state, action) => {
                state.updateApiCall = action.payload
            })

            .addCase(getValidateSCDUserDetails.fulfilled, (state, action) => {
                if (action.payload) {
                    state.ScdSpin = false
                    state.ScdSpin = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.scdDetails = action.payload.data
                }
            })
            .addCase(getWorkOrdersDataByAgentId.fulfilled, (state, action) => {
                if (action.payload) {
                    state.agentBasedCompleteData = action.payload.data
                }
            })
            .addCase(getSCDUsersByAgentId.fulfilled, (state, action) => {
                if (action.payload) {
                    state.agentBasedSCDData = action.payload.data
                }
            })
            .addCase(getAffiliatesByAgentId.fulfilled, (state, action) => {
                if (action.payload) {
                    state.agentBasedAffiliatesData = action.payload.data
                }
            }).addCase(getSEAPortalRevenues.fulfilled, (state, action) => {
                if (action.payload) {
                    state.seaPortalRevenues = action.payload.data
                    state.spinner3 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woData = action.payload.data
                    state.srRecCount = action.payload.recCount
                    state.srGridSize = action.payload.gridSize
                    state.srAgentCount = action.payload.agentsCount
                    state.srInVoiceCount = action.payload.invoiceCount
                    state.srTotalRevenue = action.payload.totalRevenue
                    state.srWorkOrderCount = action.payload.workordesCount
                    state.invoiceChartData = action.payload.invoiceChartData
                }
            }).addCase(getActiveAgentsBreakdown.fulfilled, (state, action) => {
                if (action.payload) {
                    state.activeAgentsDetails = action.payload.data
                }
            }).addCase(GetUsersByAgentIds.fulfilled, (state, action) => {
                if (action.payload) {
                    state.allAgentMapData = action.payload.data
                } else {
                    state.allAgentMapData = []
                }
            }).addCase(GetUserCompanies.fulfilled, (state, action) => {
                if (action.payload) {
                    state.allUserMapData = action.payload.data
                } else {
                    state.allUserMapData = []
                }
            }).addCase(GetCrewsList.fulfilled, (state, action) => {
                state.crewTotList = action.payload.data
            }).addCase(GetTrainingCenterEmails.fulfilled, (state, action) => {
                state.traingDirectorEmail = action.payload?.data ? action.payload?.data : []
            }).addCase(ProcessAuditReportStage.fulfilled, (state, action) => {
                if (action.payload) {
                    state.wloader = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woIdData = action.payload.data
                    state.spinner4 = action.payload.spinner
                    state.woIData = action.payload.data1
                    state.dirtyBool = false
                    if (action.payload.data) {
                        const payloadData = { ...action.payload.data }
                        if (payloadData) {
                            state.invoiceFileId = payloadData.invoiceFileId
                            state.autherizationFileId = payloadData.autherizationFileId
                        } else {
                            state.invoiceFileId = null
                            state.autherizationFileId = null
                        }
                    } else {
                        state.invoiceFileId = null
                        state.autherizationFileId = null
                    }
                    state.uploadErrMsg = ''
                }

            }).addCase(GetMPDetailsFilter.fulfilled, (state, action) => {
                if (action.payload) {
                    state.spinner3 = action.payload.spinner
                    state.tokenExp = action.payload.tokenExp
                    state.woData = action.payload.data
                    state.recCount = action.payload.recCount
                    state.gridSize = action.payload.gridSize
                }
            }).addCase(GetMPWorkOrdersDataByAgentId.fulfilled, (state, action) => {
                if (action.payload) {
                    state.agentBasedCompleteData = action.payload.data
                    state.totalMPData = action.payload.data1
                }
            })


        // .addMatcher(isPending, (state, action) => {
        //     if (!shouldTrack(action.type)) return
        //     state.activeRequests += 1
        //     state.isProcessing = true
        // }).addMatcher(isFulfilled, (state, action) => {
        //     if (!shouldTrack(action.type)) return
        //     state.activeRequests = Math.max(0, state.activeRequests - 1)
        //     state.isProcessing = state.activeRequests > 0
        // })
        // .addMatcher(isRejected, (state, action) => {
        //     if (!shouldTrack(action.type)) return
        //     state.activeRequests = Math.max(0, state.activeRequests - 1)
        //     state.isProcessing = state.activeRequests > 0
        // })

    }
})
export default commonreducerSlice.reducer
